(function () {
  var instantFilterRequestId = 0;

  // Antal valda filter i "Använd N filter", "Rensa filter" och filterknappens
  // "FILTER (N)" (Anders 2026-10-22). Många val ändrar bara adressen utan att
  // panelen hämtas om, så siffrorna räknas om här när adressen ändras.
  // Prisintervallet (två parametrar) räknas som ett filter, som i Liquid.
  function raknaValdaFilter(search) {
    var n = 0;
    var pris = false;
    new URLSearchParams(search).forEach(function (v, k) {
      if (k.indexOf('filter.v.price') === 0) {
        if (!pris) { n++; pris = true; }
      } else if (k.indexOf('filter.') === 0) {
        n++;
      }
    });
    return n;
  }

  function synkaFilterAntal() {
    var n = raknaValdaFilter(window.location.search);
    document.querySelectorAll('[data-collection-filters-apply]').forEach(function (b) {
      var en = b.getAttribute('data-lang') === 'en';
      if (en) b.textContent = n ? 'Apply ' + n + (n === 1 ? ' filter' : ' filters') : 'Apply filters';
      else b.textContent = n ? 'Använd ' + n + ' filter' : 'Använd filter';
    });
    document.querySelectorAll('[data-collection-filters-clear-all]').forEach(function (b) {
      b.disabled = !n;
    });
    document.querySelectorAll('[data-collection-filter-toggle]').forEach(function (t) {
      var sup = t.querySelector('.tambur-collection-filter-btn__count');
      if (!n) { if (sup) sup.remove(); return; }
      if (!sup) {
        sup = document.createElement('sup');
        sup.className = 'tambur-collection-filter-btn__count';
        t.appendChild(sup);
      }
      sup.textContent = '(' + n + ')';
    });
  }

  ['pushState', 'replaceState'].forEach(function (f) {
    var orig = history[f];
    history[f] = function () {
      var r = orig.apply(this, arguments);
      requestAnimationFrame(synkaFilterAntal);
      return r;
    };
  });
  window.addEventListener('popstate', function () { requestAnimationFrame(synkaFilterAntal); });

  // Tillgänglighet-sektionen har två kryssrutor: Shopifys lagerfilter och
  // butikssaldot (metafältet custom.finns_i_butik). Båda måste bort när ingen
  // av dem är ikryssad, annars ligger butikslagret kvar i adressen.
  function isAvailabilityParam(key) {
    if (key.indexOf('filter.') !== 0) return false;
    return key.indexOf('availability') !== -1 || key.indexOf('custom.finns_i_butik') !== -1;
  }

  function isInstantFilterChip(link) {
    if (!link || !link.matches('a[data-filter-chip]')) return false;
    if (link.closest('.tambur-collection-filters__section--product-type')) return false;
    if (link.classList.contains('is-disabled') || link.getAttribute('aria-disabled') === 'true') return false;
    var href = link.getAttribute('href');
    return href && href !== '#';
  }

  var KOK_COLLECTION_HANDLES = [
    'kok', 'porslin', 'duka-bordet', 'servera', 'laga-mat', 'i-koket',
    'frukostskalar', 'middagstallrikar', 'assietter', 'olivskalar', 'djupa-tallrikar',
    'salladsskalar', 'dessertskalar', 'serveringsfat', 'serveringsskalar', 'miniskalar',
    'karaffer', 'vinkylare', 'koppar-och-muggar', 'kokstextilier', 'bestick',
    'kaffekannor-och-tekannor', 'dricksglas', 'smorbyttor', 'slevhallare', 'oljekannor', 'forvaringsburkar', 'kitchen-accessories', 'koksredskap',
    'skarbrador', 'knivar-och-saxar', 'ugnsformar', 'kastruller-och-stekpannor',
    'tillredningsskalar', 'livsmedel'
  ];

  function isKokPtTag(value) {
    return String(value || '').toLowerCase().indexOf('kok-pt-') === 0;
  }

  function isTextilPtTag(value) {
    return String(value || '').toLowerCase().indexOf('textil-pt-') === 0;
  }

  function isNicolaPtTag(value) {
    return String(value || '').toLowerCase().indexOf('nicola-pt-') === 0;
  }

  function isLingeMonsterTag(value) {
    return String(value || '').toLowerCase().indexOf('linge-monster-') === 0;
  }

  function isLingePtTag(value) {
    var lc = String(value || '').toLowerCase();
    return lc.indexOf('kok-pt-') === 0 || lc === 'underkategori-prydnadskuddar';
  }

  function isTamburPtTag(value) {
    return String(value || '').toLowerCase().indexOf('tambur-pt-') === 0;
  }

  // Kategori i Detaljer (snippets/collection-filter-detaljer-grupp): underkategori-<handle>.
  // Bara Detaljers egna kategorier – underkategori-nicola-fasano-* m.fl. är mönster, inte kategorier.
  var DETALJER_KATEGORI_TAGGAR = [
    'underkategori-dekorationer', 'underkategori-korgar', 'underkategori-ljusstakar', 'underkategori-vaser',
    'underkategori-doftljus-och-rumsdoft', 'underkategori-hardtval', 'underkategori-tvalkoppar',
    'underkategori-flytade-tval', 'underkategori-skrubbar-och-borstar', 'underkategori-vaggbonader',
    'underkategori-prydnadskuddar', 'underkategori-badrumstextilier', 'underkategori-pladar'
  ];
  function isDetaljerTag(value) {
    return DETALJER_KATEGORI_TAGGAR.indexOf(String(value || '').toLowerCase()) !== -1;
  }

  function isTamburKollektionTag(value) {
    return String(value || '').toLowerCase().indexOf('tambur-kollektion-') === 0;
  }

  function isTamburFacetTag(value) {
    var lc = String(value || '').toLowerCase();
    return lc.indexOf('tambur-textil-') === 0 ||
      lc.indexOf('tambur-matt-') === 0 ||
      lc.indexOf('tambur-monster-') === 0 ||
      lc.indexOf('tambur-yta-') === 0;
  }

  function stripKokPtTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isKokPtTag);
  }

  function stripTextilPtTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isTextilPtTag);
  }

  function stripNicolaPtTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isNicolaPtTag);
  }

  function getCollectionHandleFromPath(pathname) {
    var parts = (pathname || window.location.pathname || '').split('/').filter(Boolean);
    var collectionsIdx = parts.indexOf('collections');
    if (collectionsIdx === -1 || collectionsIdx >= parts.length - 1) return '';
    return parts[collectionsIdx + 1];
  }

  function isNicolaFasanoCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'nicola-fasano';
  }

  function isCeramikaCollectionPath(pathname) {
    var handle = getCollectionHandleFromPath(pathname);
    return handle === 'ceramika-artystyczna' || handle.indexOf('ceramika-') === 0;
  }

  function isCeramikaPatternTag(value) {
    return String(value || '').toLowerCase().indexOf('underkategori-ceramika-') !== -1;
  }

  function isKokCollectionPath(pathname) {
    return KOK_COLLECTION_HANDLES.indexOf(getCollectionHandleFromPath(pathname)) !== -1;
  }

  var PORSLIN_SUB_COLLECTION_HANDLES = [
    'frukostskalar', 'middagstallrikar', 'assietter', 'olivskalar', 'djupa-tallrikar',
    'salladsskalar', 'dessertskalar', 'serveringsfat', 'serveringsskalar', 'miniskalar',
    'karaffer', 'vinkylare', 'koppar-och-muggar', 'slevhallare', 'forvaringsburkar'
  ];

  function isPorslinSubcategoryPath(pathname) {
    var handle = getCollectionHandleFromPath(pathname);
    return handle !== 'porslin' && PORSLIN_SUB_COLLECTION_HANDLES.indexOf(handle) !== -1;
  }

  function shouldKeepFullKokVendorList(drawer, urlString) {
    // Hela Kök-familjen (kök, porslin, gruppsidorna + alla underkategorier):
    // visa alltid hela varumärkeslistan, även när en produkttyp är vald. Valda
    // varumärken markeras bara — listan ska aldrig smalna av till de klickade.
    return isKokCollectionPath(window.location.pathname);
  }

  function isMattorMoblerCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'mattor-mobler';
  }

  function shouldKeepFullVendorList(drawer, urlString) {
    // Sidor där varumärkes-href:ar ska byggas om klientsidan (cache-säker multi-select):
    // Kök-familjen + Mattor & Möbler. Då tappas inte tidigare valda varumärken när man
    // klickar i ett till på en edge-cachead helsida.
    if (shouldKeepFullKokVendorList(drawer, urlString)) return true;
    return isMattorMoblerCollectionPath(window.location.pathname);
  }

  function shouldExpandPorslinVendorChips(drawer, urlString) {
    return isPorslinSubcategoryPath(window.location.pathname) && shouldKeepFullKokVendorList(drawer, urlString);
  }

  function buildVendorToggleHref(vendorLabel, makeActive, urlString) {
    var url = urlString ? new URL(urlString, window.location.origin) : new URL(window.location.href);
    url.searchParams.delete('page');
    var normalized = normalizeVendorLabel(vendorLabel);
    var current = getFilterParamValues(url, 'filter.p.vendor');
    deleteFilterParamValues(url, 'filter.p.vendor');
    current.forEach(function (vendorVal) {
      if (normalizeVendorLabel(vendorVal) !== normalized) {
        url.searchParams.append('filter.p.vendor', vendorVal);
      }
    });
    if (makeActive) {
      url.searchParams.append('filter.p.vendor', vendorLabel);
    }
    return url.pathname + url.search;
  }

  function urlFilterPairs(url) {
    var list = [];
    url.searchParams.forEach(function (value, key) {
      list.push(key + '\u0000' + value);
    });
    return list;
  }

  function appendPairToUrl(url, pair) {
    var parts = pair.split('\u0000');
    url.searchParams.append(parts[0], parts[1]);
  }

  // Chip-länkarna renderas för den adress sidan hade när lådan byggdes. Hinner man
  // klicka i ett andra filter innan förra hämtningen är klar pekar länken fortfarande
  // på det gamla läget, och första valet skrivs över. Räkna därför ut vad länken
  // ändrar jämfört med sin egen utgångsadress och lägg den ändringen på det läge
  // som är på väg in.
  function rebaseFilterHrefOnPendingUrl(href, drawer) {
    var pending = drawer && drawer._pendingFilterUrl;
    if (!href || !pending) return href;

    var origin = window.location.origin;
    var pendingUrl = new URL(pending, origin);
    var renderedUrl = new URL(window.location.href);
    var chipUrl = new URL(href, origin);
    if (pendingUrl.href === renderedUrl.href) return href;
    if (chipUrl.pathname !== renderedUrl.pathname || pendingUrl.pathname !== renderedUrl.pathname) return href;

    var renderedPairs = urlFilterPairs(renderedUrl);
    var chipPairs = urlFilterPairs(chipUrl);
    var added = chipPairs.filter(function (pair) {
      return renderedPairs.indexOf(pair) === -1;
    });
    var removed = renderedPairs.filter(function (pair) {
      return chipPairs.indexOf(pair) === -1;
    });
    if (!added.length && !removed.length) return href;

    var pendingPairs = urlFilterPairs(pendingUrl);
    var toAdd = [];
    var toRemove = [];

    // Ligger värdet redan i det läge som är på väg in vill man av med det — annars på.
    if (added.length && added.every(function (pair) { return pendingPairs.indexOf(pair) !== -1; })) {
      toRemove = added.slice();
    } else {
      toAdd = added.slice();
    }
    if (removed.length && removed.every(function (pair) { return pendingPairs.indexOf(pair) === -1; })) {
      toAdd = toAdd.concat(removed);
    } else {
      toRemove = toRemove.concat(removed);
    }

    var next = new URL(pendingUrl.pathname, origin);
    pendingPairs.forEach(function (pair) {
      if (toRemove.indexOf(pair) !== -1) return;
      appendPairToUrl(next, pair);
    });
    toAdd.forEach(function (pair) {
      if (urlFilterPairs(next).indexOf(pair) !== -1) return;
      appendPairToUrl(next, pair);
    });
    next.searchParams.delete('page');
    return next.pathname + next.search;
  }

  var porslinVendorChipCache = null;
  var porslinVendorCachePromise = null;

  function loadPorslinVendorChipCache(drawer) {
    if (porslinVendorChipCache) return Promise.resolve(porslinVendorChipCache);
    if (!drawer || !drawer.getAttribute('data-porslin-vendor-source-url')) return Promise.resolve(null);
    if (porslinVendorCachePromise) return porslinVendorCachePromise;

    var sectionId = drawer.getAttribute('data-section-id');
    var porslinUrl = drawer.getAttribute('data-porslin-vendor-source-url');
    if (!sectionId || !porslinUrl) return Promise.resolve(null);

    porslinVendorCachePromise = fetchSectionHtml(porslinUrl, sectionId)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = findVendorFilterSection(doc);
        if (!section) return null;
        var entries = [];
        section.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
          var label = collectFacetChipLabel(chip);
          if (!label) return;
          entries.push({ label: label, chip: chip.cloneNode(true) });
        });
        porslinVendorChipCache = entries.length ? entries : null;
        return porslinVendorChipCache;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        porslinVendorCachePromise = null;
      });
    return porslinVendorCachePromise;
  }

  function applyPorslinVendorChipsFromCache(drawer, urlString) {
    if (!drawer || !shouldExpandPorslinVendorChips(drawer, urlString) || !porslinVendorChipCache) return;
    var liveSection = findVendorFilterSection(drawer);
    if (!liveSection) return;
    var liveChips = liveSection.querySelector('[data-filter-chips]');
    if (!liveChips) return;

    var activeVendors = urlString
      ? getFilterParamValues(new URL(urlString, window.location.origin), 'filter.p.vendor')
      : getActiveVendorLabels(drawer);
    var hrefBase = urlString || window.location.href;
    var existing = {};
    liveChips.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
      var label = collectFacetChipLabel(chip);
      if (!label) return;
      var key = normalizeVendorLabel(label);
      existing[key] = true;
      var isActive = activeVendors.some(function (vendorVal) {
        return normalizeVendorLabel(vendorVal) === key;
      });
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('href', buildVendorToggleHref(label, !isActive, hrefBase));
    });

    porslinVendorChipCache.forEach(function (entry) {
      var key = normalizeVendorLabel(entry.label);
      if (existing[key]) return;
      var isActive = activeVendors.some(function (vendorVal) {
        return normalizeVendorLabel(vendorVal) === key;
      });
      var clone = entry.chip.cloneNode(true);
      clone.classList.toggle('is-active', isActive);
      clone.setAttribute('href', buildVendorToggleHref(entry.label, !isActive, hrefBase));
      liveChips.appendChild(clone);
      existing[key] = true;
    });
    sortVendorFilterChips(drawer);
  }

  function restoreKokVendorChipsFromPendingUrl(drawer, urlString) {
    if (!drawer || !urlString || !shouldKeepFullVendorList(drawer, urlString)) return;
    var section = findVendorFilterSection(drawer);
    if (!section) return;
    var activeVendors = getFilterParamValues(new URL(urlString, window.location.origin), 'filter.p.vendor');
    section.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
      var label = collectFacetChipLabel(chip);
      if (!label) return;
      // Inaktiva (gråade) varumärken saknar matchande produkter för aktiv produkttyp
      // — lämna dem som de är (ingen href, ej klickbara).
      if (chip.classList.contains('is-disabled')) return;
      var isActive = activeVendors.some(function (vendorVal) {
        return normalizeVendorLabel(vendorVal) === normalizeVendorLabel(label);
      });
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('href', buildVendorToggleHref(label, !isActive, urlString));
    });
  }

  function ensurePorslinSubcategoryVendorChips(drawer, urlString) {
    if (!drawer || !shouldExpandPorslinVendorChips(drawer, urlString)) return Promise.resolve();
    if (porslinVendorChipCache) {
      applyPorslinVendorChipsFromCache(drawer, urlString);
      return Promise.resolve();
    }
    return loadPorslinVendorChipCache(drawer).then(function () {
      applyPorslinVendorChipsFromCache(drawer, urlString);
    });
  }

  var TEXTIL_COLLECTION_HANDLES = ['textil', 'vaggbonader', 'badrumstextilier', 'pladar'];

  function isTextilCollectionPath(pathname) {
    return TEXTIL_COLLECTION_HANDLES.indexOf(getCollectionHandleFromPath(pathname)) !== -1;
  }

  function isLingeParticulierCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'linge-particulier';
  }

  function isTamburVendorCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'tambur';
  }

  function isPrydnadskuddarCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'prydnadskuddar';
  }

  function isBordslamporCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'bordslampor';
  }

  function isLampskarmarCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'lampskarmar';
  }

  function isLampfotterCollectionPath(pathname) {
    return getCollectionHandleFromPath(pathname) === 'lampfotter';
  }

  function isLampParentCollectionPath(pathname) {
    var handle = getCollectionHandleFromPath(pathname);
    return handle === 'belysning' || handle === 'lampor';
  }

  function isBordslamporFilterContext(pathname, activeProductTypes, activeTamburPtTags) {
    if (isBordslamporCollectionPath(pathname)) return true;
    if (isLampParentCollectionPath(pathname)) {
      if (activeProductTypes && activeProductTypes.indexOf('Bordslampor') !== -1) return true;
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.has('bord_tondo')) return true;
        if (url.searchParams.has('filter.p.m.custom.bordslampa_serie')) return true;
        var hasBordTondoTag = false;
        url.searchParams.forEach(function (val, key) {
          if (key === 'filter.p.tag' && isBordTondoTag(val)) hasBordTondoTag = true;
        });
        if (hasBordTondoTag) return true;
        url.searchParams.forEach(function (val, key) {
          if (key === 'filter.p.product_type' && String(val) === 'Bordslampor') {
            activeProductTypes = activeProductTypes || [];
            if (activeProductTypes.indexOf('Bordslampor') === -1) {
              activeProductTypes.push('Bordslampor');
            }
          }
        });
        if (activeProductTypes && activeProductTypes.indexOf('Bordslampor') !== -1) return true;
      } catch (e) {
        /* ignore */
      }
    }
    if (activeProductTypes && activeProductTypes.indexOf('Bordslampor') !== -1) return true;
    if (activeTamburPtTags && activeTamburPtTags.indexOf('tambur-pt-bordslampor') !== -1) return true;
    return false;
  }

  function isTamburFacetCollectionPath(pathname) {
    return isTamburVendorCollectionPath(pathname) || isPrydnadskuddarCollectionPath(pathname);
  }

  function isSabreCollectionPath(pathname, drawer) {
    var handle = getCollectionHandleFromPath(pathname);
    if (handle === 'sabre' || (handle && handle.indexOf('sabre-') === 0)) return true;
    if (drawer && drawer.querySelector('.tambur-collection-filters__section--sabre-series')) return true;
    return false;
  }

  var TAMBUR_PRYDNADSKUDDAR_TYPE = 'Prydnadskuddar';
  var TAMBUR_KOLLEKTION_TAGS_BY_TYPE = {
    Lampfötter: ['tambur-kollektion-tondo-piccolo', 'tambur-kollektion-tondo'],
    Lampskärmar: [
      'tambur-kollektion-ampio',
      'tambur-kollektion-cono-piccolo',
      'tambur-kollektion-cono',
    ],
    Taklampor: ['tambur-kollektion-ampio'],
  };
  var TAMBUR_TEXTIL_TYPES = ['Lampskärmar', 'Taklampor'];

  function getActiveTamburProductType(drawer) {
    if (!drawer) return '';
    var active = drawer.querySelector('[data-filter-product-type].is-active');
    return active ? String(active.getAttribute('data-product-type-value') || '').trim() : '';
  }

  function setTamburFilterChipEnabled(btn, enabled) {
    if (!btn) return;
    if (enabled) {
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
    } else {
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
      if (btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    }
  }

  function setTamburFilterSectionEnabled(section, enabled) {
    if (!section) return;
    section.classList.toggle('is-section-disabled', !enabled);
    section.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      setTamburFilterChipEnabled(btn, enabled);
    });
  }

  function setTamburKollektionChipsForType(section, activeType) {
    if (!section) return false;
    var allowedTags = TAMBUR_KOLLEKTION_TAGS_BY_TYPE[activeType] || [];
    var sectionEnabled = allowedTags.length > 0;
    section.classList.toggle('is-section-disabled', !sectionEnabled);
    section.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').toLowerCase();
      setTamburFilterChipEnabled(btn, allowedTags.indexOf(tag) !== -1);
    });
    return sectionEnabled;
  }

  function setTamburSectionCollapsed(section, collapsed) {
    if (!section) return;
    var trigger = section.querySelector('[data-filter-accordion-trigger]');
    if (collapsed) {
      section.classList.add('is-collapsed');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    } else {
      section.classList.remove('is-collapsed');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function collapseTamburDependentSections(drawer) {
    drawer.querySelectorAll(
      '.tambur-collection-filters__section--tambur-kollektion,' +
        '.tambur-collection-filters__section--tambur-textil,' +
        '.tambur-collection-filters__section--tambur-textil-ps,' +
        '.tambur-collection-filters__section--tambur-matt,' +
        '.tambur-collection-filters__section--tambur-monster,' +
        '.tambur-collection-filters__section--tambur-yta'
    ).forEach(function (section) {
      setTamburSectionCollapsed(section, true);
    });
  }

  var TAMBUR_FACET_SECTION_SELECTOR =
    '.tambur-collection-filters__section--prydnadskuddar,' +
    '.tambur-collection-filters__section--tambur-matt,' +
    '.tambur-collection-filters__section--tambur-monster,' +
    '.tambur-collection-filters__section--tambur-yta,' +
    '.tambur-collection-filters__section--tambur-textil-ps';

  function getTamburFacetDimension(tag) {
    var lc = String(tag || '').toLowerCase();
    if (lc.indexOf('tambur-matt-') === 0) return 'matt';
    if (lc.indexOf('tambur-monster-') === 0) return 'monster';
    if (lc.indexOf('tambur-yta-') === 0) return 'yta';
    if (lc.indexOf('tambur-textil-') === 0) return 'textil';
    return '';
  }

  var prydnadskuddarFacetIndexCache = null;
  var prydnadskuddarFacetIndexPromise = null;

  function parsePrydnadskuddarFacetIndex(parsed) {
    if (!parsed || !parsed.length) return null;
    return parsed.map(function (entry) {
      var facets = String(entry.f || '')
        .split(',')
        .map(function (t) {
          return t.trim().toLowerCase();
        })
        .filter(Boolean);
      return {
        facets: facets,
        vendor: String(entry.v || '').trim(),
      };
    });
  }

  function readPrydnadskuddarFacetIndexFromDom() {
    var el =
      document.querySelector('script[data-prydnadskuddar-facet-index]') ||
      document.querySelector('[data-prydnadskuddar-facet-index]');
    if (!el) return null;
    try {
      return parsePrydnadskuddarFacetIndex(JSON.parse(el.textContent || '[]'));
    } catch (err) {
      return null;
    }
  }

  function getPrydnadskuddarFacetIndexAssetUrl(drawer) {
    var root = drawer || document.querySelector('[data-collection-filters-drawer]');
    if (!root) return '';
    return String(root.getAttribute('data-prydnadskuddar-facet-index-url') || '').trim();
  }

  function ensurePrydnadskuddarFacetIndex(drawer, callback) {
    if (prydnadskuddarFacetIndexCache && prydnadskuddarFacetIndexCache.length) {
      callback(prydnadskuddarFacetIndexCache);
      return;
    }
    var fromDom = readPrydnadskuddarFacetIndexFromDom();
    if (fromDom && fromDom.length) {
      prydnadskuddarFacetIndexCache = fromDom;
      callback(fromDom);
      return;
    }
    var url = getPrydnadskuddarFacetIndexAssetUrl(drawer);
    if (!url) {
      callback(null);
      return;
    }
    if (!prydnadskuddarFacetIndexPromise) {
      prydnadskuddarFacetIndexPromise = fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('facet index fetch failed');
          return res.json();
        })
        .then(function (data) {
          var parsed = parsePrydnadskuddarFacetIndex(data);
          if (parsed && parsed.length) prydnadskuddarFacetIndexCache = parsed;
          return prydnadskuddarFacetIndexCache;
        })
        .catch(function () {
          return null;
        });
    }
    prydnadskuddarFacetIndexPromise.then(function (index) {
      callback(index);
    });
  }

  function preloadPrydnadskuddarFacetIndex() {
    if (
      !isPrydnadskuddarCollectionPath(window.location.pathname) &&
      !isTamburVendorCollectionPath(window.location.pathname)
    ) {
      return;
    }
    ensurePrydnadskuddarFacetIndex(null, function () {});
  }

  function readPrydnadskuddarFacetIndex(drawer) {
    if (prydnadskuddarFacetIndexCache && prydnadskuddarFacetIndexCache.length) {
      return prydnadskuddarFacetIndexCache;
    }
    var el =
      (drawer && drawer.querySelector('[data-prydnadskuddar-facet-index]')) ||
      document.querySelector('[data-prydnadskuddar-facet-index]');
    if (!el) return readPrydnadskuddarFacetIndexFromDom();
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return parsed.map(function (entry) {
        var facets = String(entry.f || '')
          .split(',')
          .map(function (t) {
            return t.trim().toLowerCase();
          })
          .filter(Boolean);
        return {
          facets: facets,
          vendor: String(entry.v || '').trim(),
        };
      });
    } catch (err) {
      return null;
    }
  }

  function getActiveTamburFacetTags(drawer) {
    var tags = [];
    if (!drawer) return tags;
    drawer.querySelectorAll('.tambur-collection-filters__chip--tambur-facet.is-active').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').trim().toLowerCase();
      if (tag && tags.indexOf(tag) === -1) tags.push(tag);
    });
    return tags;
  }

  function normalizeVendorLabel(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getActiveVendorLabels(drawer) {
    var vendors = [];
    var section = findVendorFilterSection(drawer);
    if (section) {
      section.querySelectorAll('[data-filter-chip].is-active').forEach(function (chip) {
        var label = collectFacetChipLabel(chip);
        if (label && vendors.indexOf(label) === -1) vendors.push(label);
      });
    }
    if (!vendors.length) {
      var url = new URL(window.location.href);
      url.searchParams.forEach(function (val, key) {
        if (key === 'filter.p.vendor' && val && vendors.indexOf(val) === -1) vendors.push(val);
      });
    }
    return vendors;
  }

  function tamburFacetProductMatches(index, requiredTags, requiredVendors) {
    if (!index || !requiredTags.length) return false;
    var vendors = requiredVendors || [];
    return index.some(function (entry) {
      if (vendors.length) {
        var entryVendor = normalizeVendorLabel(entry.vendor);
        var vendorOk = vendors.some(function (vendor) {
          return entryVendor === normalizeVendorLabel(vendor);
        });
        if (!vendorOk) return false;
      }
      return requiredTags.every(function (tag) {
        return entry.facets.indexOf(tag) !== -1;
      });
    });
  }

  function setVendorChipEnabled(chip, enabled) {
    if (!chip) return;
    if (enabled) {
      chip.classList.remove('is-disabled');
      chip.removeAttribute('aria-disabled');
      chip.removeAttribute('tabindex');
    } else {
      chip.classList.add('is-disabled');
      chip.setAttribute('aria-disabled', 'true');
      chip.setAttribute('tabindex', '-1');
      chip.classList.remove('is-active');
    }
  }

  function drawerHasPrydnadskuddarFacetSections(drawer) {
    if (!drawer) return false;
    return !!drawer.querySelector(TAMBUR_FACET_SECTION_SELECTOR);
  }

  function applyPrydnadskuddarFacetAvailability(drawer, index) {
    var activeTags = getActiveTamburFacetTags(drawer);
    var activeVendors = getActiveVendorLabels(drawer);

    drawer.querySelectorAll(TAMBUR_FACET_SECTION_SELECTOR).forEach(function (section) {
      section.querySelectorAll('.tambur-collection-filters__chip--tambur-facet').forEach(function (btn) {
        var tag = String(btn.getAttribute('data-pattern-tag') || '').trim().toLowerCase();
        if (!tag) return;
        var dim = getTamburFacetDimension(tag);
        var otherTags = activeTags.filter(function (activeTag) {
          return getTamburFacetDimension(activeTag) !== dim;
        });
        var requiredTags = otherTags.slice();
        if (requiredTags.indexOf(tag) === -1) requiredTags.push(tag);
        var available = tamburFacetProductMatches(index, requiredTags, activeVendors);
        var isActive = btn.classList.contains('is-active');

        if (!available && !isActive) {
          btn.hidden = true;
          return;
        }

        btn.hidden = false;
        setTamburFilterChipEnabled(btn, available);
        if (!available) {
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.removeAttribute('tabindex');
        }
      });
    });

    // Varumärken på prydnadskuddar: visa alltid hela listan, klickbar, även när
    // en facett (mönster/mått/yta/textil) är vald. Valda markeras bara — inget döljs
    // eller smalnar av. (Samma princip som porslin-filtret.)
    var vendorSection = findVendorFilterSection(drawer);
    if (vendorSection) {
      var chipsContainer = vendorSection.querySelector('[data-filter-chips]');
      var activeVendors = getActiveVendorLabels(drawer);
      var existingVendorKeys = {};
      var vendorTemplateChip = null;

      vendorSection.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
        var label = collectFacetChipLabel(chip);
        if (!label) return;
        existingVendorKeys[normalizeVendorLabel(label)] = true;
        if (!vendorTemplateChip) vendorTemplateChip = chip;
        chip.hidden = false;
        setVendorChipEnabled(chip, true);
      });

      // Servern smalnar av varumärken som saknar produkter för den valda facetten
      // (count 0). Återinjicera dem från facet-indexet så hela listan alltid syns.
      if (chipsContainer && vendorTemplateChip) {
        var allVendors = [];
        var seenVendor = {};
        index.forEach(function (entry) {
          var vendorLabel = String(entry.vendor || '').trim();
          if (!vendorLabel) return;
          var key = normalizeVendorLabel(vendorLabel);
          if (seenVendor[key]) return;
          seenVendor[key] = true;
          allVendors.push(vendorLabel);
        });

        allVendors.forEach(function (vendorLabel) {
          var key = normalizeVendorLabel(vendorLabel);
          if (existingVendorKeys[key]) return;
          var clone = vendorTemplateChip.cloneNode(true);
          var labelEl = clone.querySelector('.tambur-collection-filters__chip-label');
          if (labelEl) labelEl.textContent = vendorLabel;
          var isActive = activeVendors.some(function (vendorVal) {
            return normalizeVendorLabel(vendorVal) === key;
          });
          clone.classList.toggle('is-active', isActive);
          clone.hidden = false;
          setVendorChipEnabled(clone, true);
          clone.setAttribute('href', buildVendorToggleHref(vendorLabel, !isActive, window.location.href));
          chipsContainer.appendChild(clone);
          existingVendorKeys[key] = true;
        });
        sortVendorFilterChips(drawer);
      }
    }
  }

  function syncPrydnadskuddarFacetAvailability(drawer) {
    if (!drawer) return;
    if (
      !isPrydnadskuddarCollectionPath(window.location.pathname) &&
      !isTamburVendorCollectionPath(window.location.pathname) &&
      !drawerHasPrydnadskuddarFacetSections(drawer)
    ) {
      return;
    }

    ensurePrydnadskuddarFacetIndex(drawer, function (index) {
      if (!index || !index.length) return;
      applyPrydnadskuddarFacetAvailability(drawer, index);
    });
  }

  function syncTamburVendorFilterAvailability(drawer) {
    if (!drawer || !isTamburVendorCollectionPath(window.location.pathname)) return;

    var activeType = getActiveTamburProductType(drawer);
    var kollektionSection = drawer.querySelector('.tambur-collection-filters__section--tambur-kollektion');
    var bordTondoSection = drawer.querySelector('.tambur-collection-filters__section--bord-tondo');
    var textilSection = drawer.querySelector('.tambur-collection-filters__section--tambur-textil');
    var textilPsSection = drawer.querySelector('.tambur-collection-filters__section--tambur-textil-ps');
    var mattSection = drawer.querySelector('.tambur-collection-filters__section--tambur-matt');
    var monsterSection = drawer.querySelector('.tambur-collection-filters__section--tambur-monster');
    var ytaSection = drawer.querySelector('.tambur-collection-filters__section--tambur-yta');

    if (!activeType) {
      setTamburFilterSectionEnabled(kollektionSection, true);
      setTamburFilterSectionEnabled(bordTondoSection, false);
      setTamburFilterSectionEnabled(textilSection, true);
      setTamburFilterSectionEnabled(textilPsSection, false);
      setTamburFilterSectionEnabled(mattSection, false);
      setTamburFilterSectionEnabled(monsterSection, false);
      setTamburFilterSectionEnabled(ytaSection, false);
      collapseTamburDependentSections(drawer);
      return;
    }

    var kollektionEnabled = setTamburKollektionChipsForType(kollektionSection, activeType);
    var textilEnabled = TAMBUR_TEXTIL_TYPES.indexOf(activeType) !== -1;
    var prydnadskuddarEnabled = activeType === TAMBUR_PRYDNADSKUDDAR_TYPE;
    var bordTondoEnabled = activeType === 'Bordslampor';

    if (bordTondoEnabled) {
      setTamburFilterSectionEnabled(kollektionSection, false);
      setTamburFilterSectionEnabled(bordTondoSection, true);
    } else {
      setTamburFilterSectionEnabled(bordTondoSection, false);
      if (bordTondoSection) {
        bordTondoSection.querySelectorAll('[data-filter-bord-tondo].is-active').forEach(function (chip) {
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
        });
      }
    }

    setTamburFilterSectionEnabled(textilSection, textilEnabled);
    setTamburFilterSectionEnabled(textilPsSection, prydnadskuddarEnabled);
    setTamburFilterSectionEnabled(mattSection, prydnadskuddarEnabled);
    setTamburFilterSectionEnabled(monsterSection, prydnadskuddarEnabled);
    setTamburFilterSectionEnabled(ytaSection, prydnadskuddarEnabled);

    setTamburSectionCollapsed(kollektionSection, !kollektionEnabled || bordTondoEnabled);
    setTamburSectionCollapsed(bordTondoSection, !bordTondoEnabled);
    setTamburSectionCollapsed(textilSection, !textilEnabled);
    setTamburSectionCollapsed(textilPsSection, !prydnadskuddarEnabled);
    setTamburSectionCollapsed(mattSection, !prydnadskuddarEnabled);
    setTamburSectionCollapsed(monsterSection, !prydnadskuddarEnabled);
    setTamburSectionCollapsed(ytaSection, !prydnadskuddarEnabled);
  }

  function syncLampParentFilterAvailability(drawer) {
    if (!drawer || !isLampParentCollectionPath(window.location.pathname)) return;

    var activeType = '';
    drawer.querySelectorAll('[data-filter-product-type].is-active').forEach(function (btn) {
      activeType = btn.getAttribute('data-product-type-value') || '';
    });
    var bordTondoSection = drawer.querySelector('.tambur-collection-filters__section--bord-tondo');
    var bordTondoEnabled = activeType === 'Bordslampor';

    setTamburFilterSectionEnabled(bordTondoSection, bordTondoEnabled);
    setTamburSectionCollapsed(bordTondoSection, !bordTondoEnabled);
    if (!bordTondoEnabled && bordTondoSection) {
      bordTondoSection.querySelectorAll('[data-filter-bord-tondo].is-active').forEach(function (chip) {
        chip.classList.remove('is-active');
        chip.setAttribute('aria-pressed', 'false');
      });
    }
  }

  function isInstantFilterClear(link) {
    if (!link || !link.closest('.tambur-collection-filters__clear')) return false;
    var section = link.closest('.tambur-collection-filters__section');
    if (section && section.classList.contains('tambur-collection-filters__section--availability')) return false;
    var href = link.getAttribute('href');
    return href && href !== '#';
  }

  function getFiltersDrawer() {
    return document.querySelector('[data-collection-filters-drawer]');
  }

  function setFiltersDrawerLoading(drawer, loading) {
    if (!drawer) return;
    drawer.classList.toggle('is-filter-loading', loading);
    drawer.setAttribute('aria-busy', loading ? 'true' : 'false');
    var loadingEl = drawer.querySelector('[data-collection-filters-loading]');
    if (loadingEl) loadingEl.setAttribute('aria-hidden', loading ? 'false' : 'true');
  }

  function bindCloseSpin(btn, iconSelector, onFinish) {
    if (!btn || btn.getAttribute('data-close-spin-bound') === 'true') return;
    btn.setAttribute('data-close-spin-bound', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-spinning')) return;
      var icon = btn.querySelector(iconSelector);
      if (!icon) {
        onFinish();
        return;
      }
      var klar = false;
      function finishClose(ev) {
        if (ev && ev.target !== icon) return;
        if (klar) return;
        klar = true;
        icon.removeEventListener('animationend', finishClose);
        btn.classList.remove('is-spinning');
        onFinish();
      }
      btn.classList.remove('is-spinning');
      void btn.offsetWidth;
      btn.classList.add('is-spinning');
      icon.addEventListener('animationend', finishClose);
      // Reserv om animationend aldrig kommer (bakgrundsflik, animation
      // avstängd): stäng ändå strax efter snurrens 0,38 s.
      setTimeout(finishClose, 600);
    });
  }

  function getFilterParamValues(url, paramName, predicate) {
    var values = [];
    url.searchParams.forEach(function (val, key) {
      if (key === paramName && (!predicate || predicate(val))) values.push(val);
    });
    return values;
  }

  function parseOrFilterGroups(url) {
    var groups = [];
    var kokTags = getFilterParamValues(url, 'filter.p.tag', isKokPtTag);
    if (kokTags.length) groups.push({ key: 'filter.p.tag', predicate: isKokPtTag, values: kokTags });
    var kokMfValues = getFilterParamValues(url, 'filter.p.m.custom.kok_produkttyp');
    if (kokMfValues.length) groups.push({ key: 'filter.p.m.custom.kok_produkttyp', predicate: null, values: kokMfValues });
    var nicolaPtTags = getFilterParamValues(url, 'filter.p.tag', isNicolaPtTag);
    if (nicolaPtTags.length) groups.push({ key: 'filter.p.tag', predicate: isNicolaPtTag, values: nicolaPtTags });
    var patternTags = getFilterParamValues(url, 'filter.p.tag', isNicolaPatternTag);
    if (patternTags.length) groups.push({ key: 'filter.p.tag', predicate: isNicolaPatternTag, values: patternTags });
    var patternMfValues = getFilterParamValues(url, 'filter.p.m.custom.monster');
    if (patternMfValues.length) {
      groups.push({ key: 'filter.p.m.custom.monster', predicate: null, values: patternMfValues });
    }
    var lingeMonsterTags = getFilterParamValues(url, 'filter.p.tag', isLingeMonsterTag);
    if (lingeMonsterTags.length) groups.push({ key: 'filter.p.tag', predicate: isLingeMonsterTag, values: lingeMonsterTags });
    var lingePtTags = getFilterParamValues(url, 'filter.p.tag', isLingePtTag);
    if (lingePtTags.length) groups.push({ key: 'filter.p.tag', predicate: isLingePtTag, values: lingePtTags });
    var detaljerTags = getFilterParamValues(url, 'filter.p.tag', isDetaljerTag);
    if (detaljerTags.length) groups.push({ key: 'filter.p.tag', predicate: isDetaljerTag, values: detaljerTags });
    var tamburPtTags = getFilterParamValues(url, 'filter.p.tag', isTamburPtTag);
    if (tamburPtTags.length) groups.push({ key: 'filter.p.tag', predicate: isTamburPtTag, values: tamburPtTags });
    var tamburFacetTags = getFilterParamValues(url, 'filter.p.tag', isTamburFacetTag);
    if (tamburFacetTags.length) groups.push({ key: 'filter.p.tag', predicate: isTamburFacetTag, values: tamburFacetTags });
    // Facetter och serier som flyttat från taggar till metafält. monster ligger
    // redan ovan; de här är kvar av samma skäl — flerval måste räknas som OR.
    ['matt', 'yta', 'textilkollektion', 'produktserie', 'lamptyp'].forEach(function (mfKey) {
      var paramName = 'filter.p.m.custom.' + mfKey;
      var mfValues = getFilterParamValues(url, paramName);
      if (mfValues.length) groups.push({ key: paramName, predicate: null, values: mfValues });
    });
    var productTypes = getFilterParamValues(url, 'filter.p.product_type');
    if (productTypes.length) groups.push({ key: 'filter.p.product_type', predicate: null, values: productTypes });
    var vendorFilters = getFilterParamValues(url, 'filter.p.vendor');
    if (vendorFilters.length) groups.push({ key: 'filter.p.vendor', predicate: null, values: vendorFilters });
    return groups;
  }

  function cartesianCombinations(groups) {
    if (!groups.length) return [];
    var combos = groups[0].values.map(function (val) {
      return [val];
    });
    for (var i = 1; i < groups.length; i++) {
      var group = groups[i];
      var next = [];
      combos.forEach(function (combo) {
        group.values.forEach(function (val) {
          next.push(combo.concat([val]));
        });
      });
      combos = next;
    }
    return combos;
  }

  function buildOrFilterFetchUrls(baseUrl) {
    if (
      isTamburVendorCollectionPath(baseUrl.pathname) ||
      isPrydnadskuddarCollectionPath(baseUrl.pathname) ||
      isSabreCollectionPath(baseUrl.pathname)
    ) {
      return [baseUrl];
    }

    var groups = parseOrFilterGroups(baseUrl);
    if (!groups.length) return [baseUrl];

    var comboCount = 1;
    groups.forEach(function (g) {
      comboCount *= g.values.length;
    });
    if (comboCount <= 1) return [baseUrl];

    var combinations = cartesianCombinations(groups);
    return combinations.map(function (combo) {
      var u = new URL(baseUrl);
      groups.forEach(function (g, index) {
        if (g.predicate) deleteFilterParamValues(u, g.key, g.predicate);
        else deleteFilterParamValues(u, g.key);
        u.searchParams.append(g.key, combo[index]);
      });
      return u;
    });
  }

  function fetchSectionHtml(sectionUrl, sectionId) {
    var url = new URL(sectionUrl, window.location.origin);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString()).then(function (res) {
      if (!res.ok) throw new Error('filter');
      return res.text();
    });
  }

  function shouldExpandPorslinProductTypeChips(drawer) {
    return isPorslinSubcategoryPath(window.location.pathname) && getActiveVendorLabels(drawer).length === 0;
  }

  // Avgör om en produkttyp-knapp ska vara vald utifrån URL (pending eller applied).
  // Chip-X utanför lådan uppdaterar URL:en men preserve* läste tidigare bara gamla
  // is-active i DOM — då stannade Serveringssked/Tårtspade m.fl. svarta i drawern.
  function isProductTypeChipActiveInUrl(btn, url) {
    if (!btn || !url) return false;
    var typeVal = btn.getAttribute('data-product-type-value') || '';
    var typeLc = String(typeVal).toLowerCase();
    var kokMf = btn.getAttribute('data-kok-mf-value') || '';
    var kokTag = String(btn.getAttribute('data-kok-pt-tag') || '').toLowerCase();
    var tamburTag = String(btn.getAttribute('data-tambur-pt-tag') || '').toLowerCase();
    var textilTag = String(btn.getAttribute('data-textil-pt-tag') || '').toLowerCase();
    var nicolaTag = String(btn.getAttribute('data-nicola-pt-tag') || '').toLowerCase();
    var filterTypeTag = String(btn.getAttribute('data-filter-type-tag') || '').toLowerCase();

    var activeProductTypes = getFilterParamValues(url, 'filter.p.product_type');
    var activeKokMf = getFilterParamValues(url, 'filter.p.m.custom.kok_produkttyp');
    var activeTags = getFilterParamValues(url, 'filter.p.tag');
    var activeTagsLc = activeTags.map(function (t) {
      return String(t).toLowerCase();
    });
    var activeKokMfLc = activeKokMf.map(function (t) {
      return String(t).toLowerCase();
    });
    var activePtLc = activeProductTypes.map(function (t) {
      return String(t).toLowerCase();
    });

    var legacyType =
      url.searchParams.get('sabre_type') ||
      url.searchParams.get('kok_type') ||
      url.searchParams.get('nf_type') ||
      url.searchParams.get('textil_type') ||
      url.searchParams.get('linge_type') ||
      url.searchParams.get('tambur_type') ||
      '';

    return (
      (!!kokMf && activeKokMfLc.indexOf(String(kokMf).toLowerCase()) !== -1) ||
      (!!typeVal && activePtLc.indexOf(typeLc) !== -1) ||
      (!!typeVal && activeKokMfLc.indexOf(typeLc) !== -1) ||
      (!!kokTag && activeTagsLc.indexOf(kokTag) !== -1) ||
      (!!tamburTag && activeTagsLc.indexOf(tamburTag) !== -1) ||
      (!!textilTag && activeTagsLc.indexOf(textilTag) !== -1) ||
      (!!nicolaTag && activeTagsLc.indexOf(nicolaTag) !== -1) ||
      (!!filterTypeTag && activeTagsLc.indexOf(filterTypeTag) !== -1) ||
      (!!legacyType && typeVal === legacyType)
    );
  }

  function setProductTypeChipActive(btn, active) {
    if (!btn) return;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('data-initial-active', active ? 'true' : 'false');
  }

  function syncProductTypeChipsFromUrl(drawer, urlString) {
    if (!drawer) return;
    var url = new URL(urlString || window.location.href, window.location.origin);
    drawer.querySelectorAll('[data-filter-product-type]').forEach(function (btn) {
      setProductTypeChipActive(btn, isProductTypeChipActiveInUrl(btn, url));
    });
  }

  function preserveProductTypeChips(oldDrawer, newDrawer) {
    var oldSection = oldDrawer.querySelector('.tambur-collection-filters__section--product-type');
    var newSection = newDrawer.querySelector('.tambur-collection-filters__section--product-type');
    if (!oldSection || !newSection) return;
    var newGrid = newSection.querySelector('[data-filter-product-type-grid]');
    if (!newGrid) return;
    var expandPorslinChips = shouldExpandPorslinProductTypeChips(oldDrawer);
    // Pending URL är sanningen under instant-apply (chip-X, drawer-klick). Annars
    // faller vi tillbaka till gamla DOM-valet (öppen låda innan fetch hunnit sätta pending).
    var pendingUrl = oldDrawer._pendingFilterUrl || null;
    var pendingUrlObj = pendingUrl ? new URL(pendingUrl, window.location.origin) : null;
    var activeTypes = {};
    if (!pendingUrlObj) {
      oldSection.querySelectorAll('[data-filter-product-type].is-active').forEach(function (btn) {
        var key = btn.getAttribute('data-product-type-value') || '';
        if (key) activeTypes[key] = true;
      });
    }
    var existing = {};
    newGrid.querySelectorAll('[data-filter-product-type]').forEach(function (btn) {
      var key = btn.getAttribute('data-product-type-value') || '';
      if (!key) return;
      existing[key] = true;
      var shouldActive = pendingUrlObj
        ? isProductTypeChipActiveInUrl(btn, pendingUrlObj)
        : !!activeTypes[key];
      setProductTypeChipActive(btn, shouldActive);
      if (shouldActive) activeTypes[key] = true;
    });
    if (!expandPorslinChips) return;
    oldSection.querySelectorAll('[data-filter-product-type]').forEach(function (btn) {
      var key = btn.getAttribute('data-product-type-value') || '';
      if (!key || existing[key]) return;
      var clone = btn.cloneNode(true);
      var shouldActive = pendingUrlObj
        ? isProductTypeChipActiveInUrl(btn, pendingUrlObj)
        : !!activeTypes[key];
      setProductTypeChipActive(clone, shouldActive);
      newGrid.appendChild(clone);
      existing[key] = true;
    });
    sortProductTypeFilterChips(newDrawer);
  }

  function sortProductTypeFilterChips(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-filter-product-type-grid]').forEach(function (grid) {
      var chips = Array.prototype.slice.call(grid.querySelectorAll('[data-filter-product-type]'));
      if (chips.length < 2) return;
      chips.sort(function (a, b) {
        var labelA = ((a.querySelector('.tambur-collection-filters__chip-label') || a).textContent || '').trim();
        var labelB = ((b.querySelector('.tambur-collection-filters__chip-label') || b).textContent || '').trim();
        return labelA.localeCompare(labelB, 'sv', { sensitivity: 'base' });
      });
      chips.forEach(function (chip) {
        grid.appendChild(chip);
      });
    });
  }

  function isVendorFilterSection(section) {
    if (!section) return false;
    var title = section.querySelector('.tambur-collection-filters__section-title');
    if (!title) return false;
    var text = title.textContent.toLowerCase();
    return (
      text.indexOf('varumärke') !== -1 ||
      text.indexOf('vendor') !== -1 ||
      text.indexOf('säljare') !== -1 ||
      text.indexOf('seller') !== -1 ||
      text.indexOf('brand') !== -1
    );
  }

  function findVendorFilterSection(root) {
    if (!root) return null;
    var scope = root;
    if (root.nodeType === 9) {
      scope = root.querySelector('[data-collection-filters-drawer]') || root;
    } else if (!root.matches('[data-collection-filters-drawer]')) {
      var inDrawer = root.querySelector('[data-collection-filters-drawer]');
      if (inDrawer) scope = inDrawer;
    }
    var found = null;
    scope.querySelectorAll('.tambur-collection-filters__section').forEach(function (section) {
      if (!found && isVendorFilterSection(section)) found = section;
    });
    return found;
  }

  function preserveNicolaPatternChips(oldDrawer, newDrawer) {
    var oldSection = oldDrawer.querySelector(
      '.tambur-collection-filters__section--pattern:not(.tambur-collection-filters__section--linge-pattern):not(.tambur-collection-filters__section--sabre-series)'
    );
    var newSection = newDrawer.querySelector(
      '.tambur-collection-filters__section--pattern:not(.tambur-collection-filters__section--linge-pattern):not(.tambur-collection-filters__section--sabre-series)'
    );
    if (!oldSection || !newSection) return;
    var newGrid = newSection.querySelector('[data-filter-pattern-grid]');
    if (!newGrid) return;
    var existing = {};
    newGrid.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var key = btn.getAttribute('data-pattern-tag') || '';
      if (key) existing[key] = true;
    });
    oldSection.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var key = btn.getAttribute('data-pattern-tag') || '';
      if (!key || existing[key]) return;
      var clone = btn.cloneNode(true);
      clone.classList.remove('is-active');
      clone.setAttribute('aria-pressed', 'false');
      clone.setAttribute('data-initial-active', 'false');
      newGrid.appendChild(clone);
      existing[key] = true;
    });
  }

  function preserveSabreSeriesChips(oldDrawer, newDrawer) {
    var oldSection = oldDrawer.querySelector('.tambur-collection-filters__section--sabre-series');
    var newSection = newDrawer.querySelector('.tambur-collection-filters__section--sabre-series');
    if (!oldSection || !newSection) return;
    var activeTags = {};
    oldSection.querySelectorAll('[data-filter-pattern].is-active').forEach(function (btn) {
      var tag = btn.getAttribute('data-pattern-tag') || '';
      if (tag && isSabreSeriesTag(tag)) activeTags[tag.toLowerCase()] = true;
    });
    newSection.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').toLowerCase();
      if (!isSabreSeriesTag(tag)) return;
      var active = activeTags[tag] === true;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-initial-active', active ? 'true' : 'false');
    });
  }

  function syncSabreSeriesChipsFromUrl(drawer) {
    if (!drawer || !isSabreCollectionPath(window.location.pathname, drawer)) return;
    var section = drawer.querySelector('.tambur-collection-filters__section--sabre-series');
    if (!section) return;
    var url = new URL(window.location.href);
    var activeTags = [];
    var activeMfValues = [];
    var sabreSeriesHandle = url.searchParams.get('sabre_series');
    if (sabreSeriesHandle) {
      var sabreSeriesSuffix = sabreSeriesHandle.replace(/^sabre-/, '');
      if (sabreSeriesSuffix) activeTags.push('underkategori-sabre-' + sabreSeriesSuffix);
    }
    url.searchParams.forEach(function (val, key) {
      if (key === 'filter.p.m.custom.produktserie' && val) {
        activeMfValues.push(String(val).toLowerCase());
      }
    });
    if (activeTags.length === 0) {
      url.searchParams.forEach(function (val, key) {
        if (key === 'filter.p.tag' && isSabreSeriesTag(val)) activeTags.push(String(val).toLowerCase());
      });
    }
    section.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').toLowerCase();
      if (!isSabreSeriesTag(tag)) return;
      var mfValue = String(btn.getAttribute('data-pattern-mf-value') || '').toLowerCase();
      var active = activeTags.indexOf(tag) !== -1 || (!!mfValue && activeMfValues.indexOf(mfValue) !== -1);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-initial-active', active ? 'true' : 'false');
    });
  }

  function preserveVendorChips(oldDrawer, newDrawer) {
    var pendingUrl = oldDrawer._pendingFilterUrl || null;
    var activeFromUrl = pendingUrl
      ? getFilterParamValues(new URL(pendingUrl, window.location.origin), 'filter.p.vendor')
      : [];
    var oldSection = findVendorFilterSection(oldDrawer);
    var newSection = findVendorFilterSection(newDrawer);
    if (!oldSection || !newSection) return;
    var newChips = newSection.querySelector('[data-filter-chips]');
    if (!newChips) return;
    var activeLabels = {};
    oldSection.querySelectorAll('[data-filter-chip].is-active').forEach(function (chip) {
      var key = collectFacetChipLabel(chip);
      if (key) activeLabels[key] = true;
    });
    activeFromUrl.forEach(function (vendorVal) {
      if (vendorVal) activeLabels[vendorVal] = true;
    });
    var keepFullVendors =
      shouldKeepFullKokVendorList(oldDrawer, pendingUrl) ||
      (oldDrawer && oldDrawer.getAttribute('data-keep-full-vendors') === 'true');
    var existing = {};
    newChips.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
      var key = collectFacetChipLabel(chip);
      if (!key) return;
      existing[normalizeVendorLabel(key)] = true;
      var isActive =
        activeLabels[key] === true ||
        activeFromUrl.some(function (vendorVal) {
          return normalizeVendorLabel(vendorVal) === normalizeVendorLabel(key);
        }) ||
        chip.classList.contains('is-active');
      chip.classList.toggle('is-active', isActive);
      if (isActive) activeLabels[key] = true;
    });
    if (keepFullVendors) {
      oldSection.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
        var key = collectFacetChipLabel(chip);
        if (!key) return;
        var normalizedKey = normalizeVendorLabel(key);
        if (existing[normalizedKey]) return;
        var clone = chip.cloneNode(true);
        var isActive =
          activeLabels[key] === true ||
          activeFromUrl.some(function (vendorVal) {
            return normalizeVendorLabel(vendorVal) === normalizedKey;
          });
        clone.classList.toggle('is-active', isActive);
        if (pendingUrl) {
          clone.setAttribute('href', buildVendorToggleHref(key, !isActive, pendingUrl));
        }
        newChips.appendChild(clone);
        existing[normalizedKey] = true;
      });
    }
    if (shouldExpandPorslinVendorChips(oldDrawer, pendingUrl)) {
      applyPorslinVendorChipsFromCache(newDrawer, pendingUrl);
    }
    if (keepFullVendors && pendingUrl) {
      restoreKokVendorChipsFromPendingUrl(newDrawer, pendingUrl);
    }
    sortVendorFilterChips(newDrawer);
  }

  function sortVendorFilterChips(drawer) {
    var section = findVendorFilterSection(drawer);
    if (!section) return;
    var container = section.querySelector('[data-filter-chips]');
    if (!container) return;
    var chips = Array.prototype.slice.call(container.querySelectorAll('[data-filter-chip]'));
    if (chips.length < 2) return;
    chips.sort(function (a, b) {
      var labelA = collectFacetChipLabel(a);
      var labelB = collectFacetChipLabel(b);
      return labelA.localeCompare(labelB, 'sv', { sensitivity: 'base' });
    });
    chips.forEach(function (chip) {
      container.appendChild(chip);
    });
  }

  function syncVendorChipsFromUrl(drawer, urlString) {
    var section = findVendorFilterSection(drawer);
    if (!section) return;
    var url = urlString ? new URL(urlString, window.location.origin) : new URL(window.location.href);
    var activeVendors = getFilterParamValues(url, 'filter.p.vendor');
    section.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
      var label = collectFacetChipLabel(chip);
      if (!label) return;
      if (chip.classList.contains('is-disabled')) return;
      var isActive = activeVendors.some(function (vendorVal) {
        return normalizeVendorLabel(vendorVal) === normalizeVendorLabel(label);
      });
      chip.classList.toggle('is-active', isActive);
      if (shouldKeepFullVendorList(drawer, urlString || url.href)) {
        chip.setAttribute('href', buildVendorToggleHref(label, !isActive, urlString || url.href));
      }
    });
  }

  function syncSabreProductTypeChipsFromUrl(drawer) {
    // Sabré produkttyp filtreras via custom.kok_produkttyp (metafält), inte bara
    // legacy sabre_type / kok-pt-*. Om vi bara läser de äldre parametrarna nollas
    // is-active efter instant-apply — då bygger Visa en URL utan filter och
    // rensar valet (samma symptom som "Visa gör ingenting").
    if (!drawer || !isSabreCollectionPath(window.location.pathname, drawer)) return;
    var section = drawer.querySelector('.tambur-collection-filters__section--product-type');
    if (!section) return;
    var url = new URL(window.location.href);
    section.querySelectorAll('[data-filter-product-type]').forEach(function (btn) {
      setProductTypeChipActive(btn, isProductTypeChipActiveInUrl(btn, url));
    });
  }

  function preserveTamburKollektionChips(oldDrawer, newDrawer) {
    var oldSection = oldDrawer.querySelector('.tambur-collection-filters__section--tambur-kollektion');
    var newSection = newDrawer.querySelector('.tambur-collection-filters__section--tambur-kollektion');
    if (!oldSection || !newSection) return;
    var activeTags = {};
    oldSection.querySelectorAll('[data-filter-pattern].is-active').forEach(function (btn) {
      var tag = btn.getAttribute('data-pattern-tag') || '';
      if (tag && isTamburKollektionTag(tag)) activeTags[tag.toLowerCase()] = true;
    });
    newSection.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').toLowerCase();
      if (!isTamburKollektionTag(tag)) return;
      var active = activeTags[tag] === true;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-initial-active', active ? 'true' : 'false');
    });
  }

  function syncTamburKollektionChipsFromUrl(drawer) {
    if (!drawer || !isTamburVendorCollectionPath(window.location.pathname)) return;
    var section = drawer.querySelector('.tambur-collection-filters__section--tambur-kollektion');
    if (!section) return;
    var url = new URL(window.location.href);
    var activeSlugs = [];
    url.searchParams.forEach(function (val, key) {
      if (key === 'tambur_kol' && val) activeSlugs.push(String(val).toLowerCase());
    });
    section.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var tag = String(btn.getAttribute('data-pattern-tag') || '').toLowerCase();
      if (!isTamburKollektionTag(tag)) return;
      var slug = tag.replace(/^tambur-kollektion-/, '');
      var active = activeSlugs.indexOf(slug) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-initial-active', active ? 'true' : 'false');
    });
  }

  function syncBordTondoChipsFromUrl(drawer) {
    if (!drawer) return;
    var section = drawer.querySelector('.tambur-collection-filters__section--bord-tondo');
    if (!section) return;
    var url = new URL(window.location.href);
    var activeValues = [];
    url.searchParams.forEach(function (val, key) {
      // Matchar mot sektionens egna chip-värden nedan, så alla filter.p.tag
      // kan samlas (bord-tondo och lampskärm-typ delar samma sektion/JS).
      if (key === 'filter.p.tag') {
        activeValues.push(String(val).toLowerCase());
      }
    });
    var legacy = String(url.searchParams.get('bord_tondo') || '').toLowerCase();
    if (legacy) activeValues.push(legacy);
    url.searchParams.getAll('filter.p.m.custom.bordslampa_serie').forEach(function (val) {
      if (val) activeValues.push(String(val).toLowerCase());
    });
    section.querySelectorAll('[data-filter-bord-tondo]').forEach(function (btn) {
      var val = String(btn.getAttribute('data-bord-tondo-value') || '').toLowerCase();
      var active = val !== '' && activeValues.indexOf(val) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-initial-active', active ? 'true' : 'false');
    });
  }

  function stripTamburKolForBordslamporFilter() {
    if (!isTamburVendorCollectionPath(window.location.pathname)) return false;
    var url = new URL(window.location.href);
    var bordslamporActive = url.searchParams.get('tambur_type') === 'Bordslampor';
    if (!bordslamporActive) {
      url.searchParams.forEach(function (val, key) {
        if (key === 'filter.p.tag' && String(val).toLowerCase() === 'tambur-pt-bordslampor') {
          bordslamporActive = true;
        }
      });
    }
    if (!bordslamporActive) return false;
    var hadKol = false;
    url.searchParams.forEach(function (_val, key) {
      if (key === 'tambur_kol') hadKol = true;
    });
    if (!hadKol) return false;
    stripTamburKolParams(url);
    url.searchParams.delete('page');
    window.location.replace(url.pathname + url.search);
    return true;
  }

  function migrateSabreSeriesUrlParams() {
    if (!isSabreCollectionPath(window.location.pathname)) return false;
    var url = new URL(window.location.href);
    var seriesHandle = url.searchParams.get('sabre_series');
    if (!seriesHandle) return false;
    var seriesSuffix = seriesHandle.replace(/^sabre-/, '');
    if (!seriesSuffix) return false;
    var seriesTag = 'underkategori-sabre-' + seriesSuffix;
    var hasSeriesTag = false;
    url.searchParams.forEach(function (val, key) {
      if (key === 'filter.p.tag' && String(val).toLowerCase() === seriesTag) hasSeriesTag = true;
    });
    if (hasSeriesTag) return false;
    url.searchParams.append('filter.p.tag', seriesTag);
    url.searchParams.delete('page');
    window.location.replace(url.pathname + url.search);
    return true;
  }

  function migrateTamburKollektionUrlParams() {
    if (!isTamburVendorCollectionPath(window.location.pathname)) return false;
    var url = new URL(window.location.href);
    var kolSlugs = [];
    var legacyTags = [];
    url.searchParams.forEach(function (val, key) {
      if (key === 'filter.p.tag' && isTamburKollektionTag(val)) {
        legacyTags.push(val);
        kolSlugs.push(String(val).replace(/^tambur-kollektion-/i, ''));
      }
    });
    if (!legacyTags.length) return false;
    legacyTags.forEach(function (val) {
      url.searchParams.delete('filter.p.tag', val);
    });
    kolSlugs.forEach(function (slug) {
      if (slug) url.searchParams.append('tambur_kol', slug);
    });
    url.searchParams.delete('page');
    window.location.replace(url.pathname + url.search);
    return true;
  }

  function preserveLingePatternChips(oldDrawer, newDrawer) {
    var oldSection = oldDrawer.querySelector('.tambur-collection-filters__section--linge-pattern');
    var newSection = newDrawer.querySelector('.tambur-collection-filters__section--linge-pattern');
    if (!oldSection || !newSection) return;
    var newChips = newSection.querySelector('[data-filter-chips]');
    if (!newChips) return;
    var existing = {};
    newChips.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var key = btn.getAttribute('data-pattern-tag') || '';
      if (key) existing[key] = true;
    });
    oldSection.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      var key = btn.getAttribute('data-pattern-tag') || '';
      if (!key || existing[key]) return;
      var clone = btn.cloneNode(true);
      clone.classList.remove('is-active');
      clone.setAttribute('aria-pressed', 'false');
      clone.setAttribute('data-initial-active', 'false');
      newChips.appendChild(clone);
      existing[key] = true;
    });
  }

  function applyDrawerAndToggleFromDoc(doc, wasDrawerOpen) {
    var newIndex = doc.querySelector('[data-prydnadskuddar-facet-index]');
    var liveIndex = document.querySelector('[data-prydnadskuddar-facet-index]');
    if (newIndex && liveIndex) {
      liveIndex.textContent = newIndex.textContent;
      prydnadskuddarFacetIndexCache = null;
      prydnadskuddarFacetIndexPromise = null;
    } else if (newIndex && !liveIndex) {
      var anchor = document.querySelector('[data-collection-filters-drawer]');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(document.importNode(newIndex, true), anchor);
      }
    }

    var newDrawer = doc.querySelector('[data-collection-filters-drawer]');
    var liveDrawer = getFiltersDrawer();
    if (newDrawer && liveDrawer && liveDrawer.parentNode) {
      var wasFilterLoading = liveDrawer.classList.contains('is-filter-loading');
      if (liveDrawer._pendingFilterUrl) {
        newDrawer._pendingFilterUrl = liveDrawer._pendingFilterUrl;
      }
      preserveProductTypeChips(liveDrawer, newDrawer);
      preserveNicolaPatternChips(liveDrawer, newDrawer);
      preserveSabreSeriesChips(liveDrawer, newDrawer);
      preserveVendorChips(liveDrawer, newDrawer);
      preserveLingePatternChips(liveDrawer, newDrawer);
      preserveTamburKollektionChips(liveDrawer, newDrawer);
      liveDrawer.replaceWith(document.importNode(newDrawer, true));
      var updatedDrawer = document.querySelector('[data-collection-filters-drawer]');
      if (updatedDrawer) {
        if (wasFilterLoading) setFiltersDrawerLoading(updatedDrawer, true);
        if (wasDrawerOpen) {
          updatedDrawer.classList.add('is-open');
          updatedDrawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('tambur-collection-filters-open');
        }
        syncPrydnadskuddarFacetAvailability(updatedDrawer);
        var pendingUrl = updatedDrawer._pendingFilterUrl || liveDrawer._pendingFilterUrl || null;
        ensurePorslinSubcategoryVendorChips(updatedDrawer, pendingUrl);
        restoreKokVendorChipsFromPendingUrl(updatedDrawer, pendingUrl);
      }
    }

    var newToggle = doc.querySelector('[data-collection-filter-toggle]');
    var oldToggle = document.querySelector('[data-collection-filter-toggle]');
    if (newToggle && oldToggle) {
      oldToggle.replaceWith(document.importNode(newToggle, true));
      if (wasDrawerOpen) {
        var updatedToggle = document.querySelector('[data-collection-filter-toggle]');
        if (updatedToggle) {
          updatedToggle.setAttribute('aria-expanded', 'true');
          updatedToggle.classList.add('is-active');
        }
      }
    }

    var newActive = doc.querySelector('[data-collection-active-filters]');
    var oldActive = document.querySelector('[data-collection-active-filters]');
    if (newActive && oldActive) {
      oldActive.replaceWith(document.importNode(newActive, true));
    }
    /* [antal] efter titeln (sidhuvudet i Hermès-stil) */
    var newBracket = doc.querySelector('[data-collection-bracket-count]');
    var oldBracket = document.querySelector('[data-collection-bracket-count]');
    if (newBracket && oldBracket) oldBracket.textContent = newBracket.textContent;
  }

  function applyMergedGridFromHtmls(htmls) {
    var handlesSeen = {};
    var mergedCards = [];
    var templateWrap = null;

    var mergedTiles = [];
    var tilesSeen = {};
    htmls.forEach(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!templateWrap) templateWrap = doc.querySelector('[data-collection-infinite]');
      var grid = doc.querySelector('[data-collection-grid]');
      if (!grid) return;
      grid.querySelectorAll('.tambur-product-card').forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        if (!handle || handlesSeen[handle]) return;
        handlesSeen[handle] = true;
        mergedCards.push(document.importNode(card, true));
      });
      grid.querySelectorAll('[data-insp]').forEach(function (tile) {
        var key = tile.getAttribute('data-insp-after') + ':' + (tile.getAttribute('data-insp-id') || tile.innerHTML.slice(0, 40));
        if (tilesSeen[key]) return;
        tilesSeen[key] = true;
        mergedTiles.push({
          after: parseInt(tile.getAttribute('data-insp-after'), 10) || 0,
          el: document.importNode(tile, true)
        });
      });
    });
    mergedTiles.sort(function (a, b) { return a.after - b.after; });

    var oldGridWrap = document.querySelector('[data-collection-infinite]');
    if (!oldGridWrap || !templateWrap) return;

    var newGridWrap = document.importNode(templateWrap, true);
    newGridWrap.setAttribute('data-products-count', String(mergedCards.length));
    newGridWrap.removeAttribute('data-next-url');
    var sentinel = newGridWrap.querySelector('[data-infinite-sentinel]');
    if (sentinel) sentinel.remove();
    var status = newGridWrap.querySelector('[data-infinite-status]');
    if (status) status.remove();

    var grid = newGridWrap.querySelector('[data-collection-grid]');
    if (grid) {
      grid.innerHTML = '';
      var tileIdx = 0;
      mergedCards.forEach(function (card, i) {
        grid.appendChild(card);
        while (tileIdx < mergedTiles.length && mergedTiles[tileIdx].after === i + 1) {
          grid.appendChild(mergedTiles[tileIdx].el);
          tileIdx += 1;
        }
      });
      while (tileIdx < mergedTiles.length) {
        grid.appendChild(mergedTiles[tileIdx].el);
        tileIdx += 1;
      }
    }

    oldGridWrap.replaceWith(newGridWrap);
  }

  function readSectionProductCount(doc) {
    if (!doc) return null;
    var wrap = doc.querySelector('[data-collection-infinite]');
    if (wrap) {
      var fromAttr = parseInt(wrap.getAttribute('data-products-count'), 10);
      if (!isNaN(fromAttr)) return fromAttr;
    }
    var hidden = doc.querySelector('[data-collection-products-count]');
    if (hidden) {
      var fromHidden = parseInt(hidden.textContent.trim(), 10);
      if (!isNaN(fromHidden)) return fromHidden;
    }
    return null;
  }

  function sumOrFilterProductCounts(htmls) {
    var total = 0;
    htmls.forEach(function (html) {
      var n = readSectionProductCount(new DOMParser().parseFromString(html, 'text/html'));
      if (n !== null) total += n;
    });
    return total;
  }

  function hasOrFilterGroupsInUrl(url) {
    var groups = parseOrFilterGroups(url);
    if (!groups.length) return false;
    if (groups.length > 1) return true;
    return groups[0].values.length > 1;
  }

  function buildInstantChipHref(urlAdd, urlRemove, isCurrentlyActive) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (urlAdd && urlRemove) {
      applyShopifyFilterUrl(url, urlAdd, urlRemove, !isCurrentlyActive);
    }
    return url.toString();
  }

  function collectFacetChipLabel(chip) {
    var label = chip.querySelector('.tambur-collection-filters__chip-label');
    return label ? label.textContent.trim() : '';
  }

  function collectFacetChipsFromDoc(doc) {
    var chips = [];
    doc.querySelectorAll(
      '.tambur-collection-filters__section:not(.tambur-collection-filters__section--product-type):not(.tambur-collection-filters__section--availability) [data-filter-chip]'
    ).forEach(function (chip) {
      var key = collectFacetChipLabel(chip);
      if (key) chips.push({ key: key, chip: chip });
    });
    return chips;
  }

  function collectVendorChipsFromDoc(doc) {
    var chips = [];
    var section = findVendorFilterSection(doc);
    if (!section) return chips;
    section.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
      var key = collectFacetChipLabel(chip);
      if (key) chips.push({ key: key, chip: chip });
    });
    return chips;
  }

  function collectVendorsFromGridHtmls(htmls) {
    var vendors = {};
    if (!htmls || !htmls.length) return vendors;
    htmls.forEach(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-collection-grid] .tambur-product-card').forEach(function (card) {
        var vendor = card.getAttribute('data-product-vendor');
        if (vendor) vendors[vendor.trim()] = true;
      });
    });
    return vendors;
  }

  function mergeOrFacetFiltersFromHtmls(htmls) {
    var drawer = getFiltersDrawer();
    if (!drawer || !htmls || !htmls.length) return;

    var pendingUrl = drawer._pendingFilterUrl || null;
    var keepFullKokVendors = shouldKeepFullKokVendorList(drawer, pendingUrl);

    var vendorData = {};
    var vendorChipTemplates = {};
    var availabilityData = {};

    var fetchedFacetChipCount = 0;
    htmls.forEach(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      collectVendorChipsFromDoc(doc).forEach(function (entry) {
        fetchedFacetChipCount += 1;
        var chip = entry.chip;
        var key = entry.key;
        if (!vendorData[key]) vendorData[key] = { enabled: false, add: '', remove: '' };
        if (!chip.classList.contains('is-disabled')) {
          vendorData[key].enabled = true;
          if (!vendorChipTemplates[key]) vendorChipTemplates[key] = chip;
        }
        var href = chip.getAttribute('href') || '';
        if (chip.classList.contains('is-active') && href) vendorData[key].remove = href;
        else if (href) vendorData[key].add = href;
      });

      doc.querySelectorAll('[data-filter-availability]').forEach(function (btn) {
        var labelEl = btn.querySelector('.tambur-collection-filters__checkbox-label');
        var key = labelEl ? labelEl.textContent.trim() : '';
        if (!key) return;
        if (!availabilityData[key]) {
          availabilityData[key] = {
            enabled: false,
            count: 0,
            add: btn.getAttribute('data-url-add') || '',
            remove: btn.getAttribute('data-url-remove') || '',
          };
        }
        if (!btn.disabled && !btn.classList.contains('is-disabled')) {
          availabilityData[key].enabled = true;
        }
        var countEl = btn.querySelector('.tambur-collection-filters__checkbox-count');
        var count = countEl ? parseInt(countEl.textContent.trim(), 10) : 0;
        if (!isNaN(count)) availabilityData[key].count += count;
        if (btn.getAttribute('data-url-add')) availabilityData[key].add = btn.getAttribute('data-url-add');
        if (btn.getAttribute('data-url-remove')) availabilityData[key].remove = btn.getAttribute('data-url-remove');
      });
    });

    if (!fetchedFacetChipCount && !keepFullKokVendors) return;

    var gridVendors = collectVendorsFromGridHtmls(htmls);
    if (
      Object.keys(gridVendors).length > 0 &&
      !isPorslinSubcategoryPath(window.location.pathname) &&
      !keepFullKokVendors
    ) {
      var gridVendorsLower = {};
      Object.keys(gridVendors).forEach(function (vendorKey) {
        gridVendorsLower[vendorKey.toLowerCase()] = true;
      });
      Object.keys(vendorData).forEach(function (key) {
        if (!gridVendorsLower[key.toLowerCase()]) vendorData[key].enabled = false;
      });
    }

    if (!keepFullKokVendors) {
      var vendorSection = findVendorFilterSection(drawer);
      if (!vendorSection) {
        htmls.forEach(function (html) {
          if (vendorSection) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var srcSection = findVendorFilterSection(doc);
          if (!srcSection) return;
          var inner = drawer.querySelector('.tambur-collection-filters__inner');
          if (!inner) return;
          vendorSection = document.importNode(srcSection, true);
          var ptSection = inner.querySelector('.tambur-collection-filters__section--product-type');
          if (ptSection) {
            inner.insertBefore(vendorSection, ptSection.nextSibling);
          } else {
            inner.insertBefore(vendorSection, inner.firstChild);
          }
        });
      }

      if (vendorSection) {
        var vendorChipsContainer = vendorSection.querySelector('[data-filter-chips]');
        if (vendorChipsContainer) {
          var activeVendorKeys = [];
          Object.keys(vendorData).forEach(function (key) {
            if (vendorData[key] && vendorData[key].enabled) activeVendorKeys.push(key);
          });
          activeVendorKeys.sort();

          if (activeVendorKeys.length) {
            vendorChipsContainer.innerHTML = '';
            activeVendorKeys.forEach(function (key) {
              var data = vendorData[key];
              var template = vendorChipTemplates[key];
              if (!data || !template) return;
              var clone = template.cloneNode(true);
              var isActive = clone.classList.contains('is-active');
              clone.classList.remove('is-disabled');
              clone.hidden = false;
              clone.removeAttribute('aria-disabled');
              clone.removeAttribute('tabindex');
              if (data.add && data.remove) {
                clone.setAttribute('href', buildInstantChipHref(data.add, data.remove, isActive));
              } else if (!isActive && data.add) {
                clone.setAttribute('href', buildInstantChipHref(data.add, data.add, false));
              } else if (isActive && data.remove) {
                clone.setAttribute('href', buildInstantChipHref(data.remove, data.remove, true));
              }
              vendorChipsContainer.appendChild(clone);
            });
            sortVendorFilterChips(drawer);
          }
        }
      }
    }

    if (keepFullKokVendors) {
      // OR-union vid flerval: Shopifys varumärkesfacett räknar AND (produkten måste ha
      // ALLA valda taggar) → alla 0 när två produkttyper väljs. Per-kombination-
      // fetcharna ger däremot rätt info: ett varumärke är valbart om det matchar NÅGON
      // av de valda typerna. Sätt is-disabled utifrån den unionen.
      var vendorSectionUnion = findVendorFilterSection(drawer);
      if (vendorSectionUnion && Object.keys(vendorData).length) {
        var vendorEnabledByKey = {};
        Object.keys(vendorData).forEach(function (key) {
          vendorEnabledByKey[normalizeVendorLabel(key)] = !!(vendorData[key] && vendorData[key].enabled);
        });
        vendorSectionUnion.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
          var label = collectFacetChipLabel(chip);
          if (!label) return;
          var enabled = vendorEnabledByKey[normalizeVendorLabel(label)];
          if (chip.classList.contains('is-active')) enabled = true;
          if (enabled) {
            chip.classList.remove('is-disabled');
            chip.removeAttribute('aria-disabled');
            chip.removeAttribute('tabindex');
          } else {
            chip.classList.add('is-disabled');
            chip.setAttribute('aria-disabled', 'true');
            chip.setAttribute('tabindex', '-1');
            chip.classList.remove('is-active');
            chip.removeAttribute('href');
          }
        });
      }
      if (shouldExpandPorslinVendorChips(drawer, pendingUrl)) {
        applyPorslinVendorChipsFromCache(drawer, pendingUrl);
      }
      restoreKokVendorChipsFromPendingUrl(drawer, pendingUrl);
    }

    drawer.querySelectorAll('[data-filter-availability]').forEach(function (btn) {
      var labelEl = btn.querySelector('.tambur-collection-filters__checkbox-label');
      var key = labelEl ? labelEl.textContent.trim() : '';
      var data = availabilityData[key];
      if (!data || !data.enabled) {
        btn.hidden = true;
        return;
      }
      btn.hidden = false;
      btn.classList.remove('is-disabled');
      btn.disabled = false;
      var countEl = btn.querySelector('.tambur-collection-filters__checkbox-count');
      if (countEl && data.count > 0) countEl.textContent = String(data.count);
      if (data.add) btn.setAttribute('data-url-add', data.add);
      if (data.remove) btn.setAttribute('data-url-remove', data.remove);
      if (btn._availabilityState) {
        btn._availabilityState.revert = function () {
          var initialActive = btn.getAttribute('data-initial-active') === 'true';
          btn.classList.toggle('is-active', initialActive);
          btn.setAttribute('aria-checked', initialActive ? 'true' : 'false');
        };
      }
    });
  }

  function countUniqueCardsInHtmls(htmls) {
    var seen = {};
    var total = 0;
    htmls.forEach(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('[data-collection-grid]');
      if (!grid) return;
      grid.querySelectorAll('.tambur-product-card').forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        total += 1;
      });
    });
    return total;
  }

  function syncOrFacetsIfNeeded(drawer) {
    if (!drawer) return;
    var url = new URL(window.location.href);
    if (!hasOrFilterGroupsInUrl(url)) return;
    var sectionId = drawer.getAttribute('data-section-id');
    if (!sectionId) return;
    var fetchUrls = buildOrFilterFetchUrls(url);
    if (fetchUrls.length <= 1) return;
    Promise.all(
      fetchUrls.map(function (u) {
        return fetchSectionHtml(u, sectionId);
      })
    )
      .then(function (htmls) {
        mergeOrFacetFiltersFromHtmls(htmls);
        // Edge-cachen kan kollapsa upprepade filter.p.*-nycklar (?a=X&a=Y) till ett
        // enda värde innan Shopify renderar helsidan, så SSR-griden visar bara ett av
        // OR-värdena. Varje fetchUrl ovan har EXAKT ett värde (inga dubblettnycklar) →
        // hämtas korrekt. Slå därför ihop dem klient-sidan om SSR-griden inte redan
        // motsvarar unionen. Hämtningarna är redan gjorda för facetterna ovan.
        var unionCount = countUniqueCardsInHtmls(htmls);
        var currentWrap = document.querySelector('[data-collection-infinite]');
        var currentCount = currentWrap
          ? currentWrap.querySelectorAll('.tambur-product-card').length
          : 0;
        if (unionCount > 0 && unionCount !== currentCount) {
          applyMergedGridFromHtmls(htmls);
          setFilterProductCount(unionCount);
        }
      })
      .catch(function () {});
  }

  function setFilterProductCount(count) {
    var countStr = String(count);
    document.querySelectorAll('[data-collection-filter-count]').forEach(function (el) {
      el.textContent = countStr;
    });
    var drawer = getFiltersDrawer();
    if (drawer) {
      var hidden = drawer.querySelector('[data-collection-products-count]');
      if (hidden) hidden.textContent = countStr;
      drawer.setAttribute('data-base-products-count', countStr);
    }
    var wrap = document.querySelector('[data-collection-infinite]');
    if (wrap) wrap.setAttribute('data-products-count', countStr);
    document.querySelectorAll('[data-collection-title-count]').forEach(function (el) {
      el.textContent = countStr + ' produkter';
    });
    document.querySelectorAll('[data-collection-bracket-count]').forEach(function (el) {
      el.textContent = '[' + countStr + ']';
    });
    syncFilterToggleCountFromDrawer();
  }

  function syncFilterToggleCountFromDrawer() {
    /* Filter-knappen visar bara "Filter" (Toteme-stil); räknare finns i filterpanelen. */
  }

  function finishInstantFilterApply(urlString, wasDrawerOpen) {
    var navUrl = new URL(urlString, window.location.origin);
    navUrl.searchParams.delete('page');
    history.pushState(null, '', navUrl.pathname + navUrl.search);

    var drawerAfterNav = getFiltersDrawer();
    if (drawerAfterNav) delete drawerAfterNav._pendingFilterUrl;

    if (window.tamburCollectionGridInit) {
      window.tamburCollectionGridInit(document);
    }
    initCollectionFilters(document);
    if (wasDrawerOpen) {
      var openDrawer = getFiltersDrawer();
      var openToggle = document.querySelector('[data-collection-filter-toggle]');
      if (openDrawer) {
        openDrawer.classList.add('is-open');
        openDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tambur-collection-filters-open');
      }
      if (openToggle) {
        openToggle.setAttribute('aria-expanded', 'true');
        openToggle.classList.add('is-active');
      }
    }
    syncFilterToggleCountFromDrawer();
    syncPrydnadskuddarFacetAvailability(getFiltersDrawer());
    document.dispatchEvent(new CustomEvent('tambur:favorites-sync'));
    document.dispatchEvent(new CustomEvent('tambur:collection:grid-updated', { bubbles: true }));
  }

  function applyCollectionFiltersInstant(urlString, drawerRef) {
    var drawer = drawerRef && drawerRef.isConnected ? drawerRef : getFiltersDrawer();
    var sectionId =
      (drawer && drawer.getAttribute('data-section-id')) ||
      (document.querySelector('[data-collection-infinite]') &&
        document.querySelector('[data-collection-infinite]').getAttribute('data-section-id'));
    if (!sectionId) {
      window.location.href = urlString;
      return;
    }

    var targetUrl = new URL(urlString, window.location.origin);
    // Annan sida (gruppsidan från en undersida i Kök): ladda den på riktigt, rubrik och rad följer med
    if (targetUrl.pathname !== window.location.pathname) {
      window.location.href = targetUrl.pathname + targetUrl.search;
      return;
    }
    var id = ++instantFilterRequestId;
    targetUrl.searchParams.delete('page');
    if (drawer) drawer._pendingFilterUrl = targetUrl.toString();
    var fetchUrls = buildOrFilterFetchUrls(targetUrl);
    var wasDrawerOpen = drawer && drawer.classList.contains('is-open');
    var gridWrap = document.querySelector('[data-collection-infinite]');
    if (gridWrap) gridWrap.classList.add('is-loading');
    if (drawer && wasDrawerOpen) setFiltersDrawerLoading(drawer, true);

    Promise.all(fetchUrls.map(function (u) {
      return fetchSectionHtml(u, sectionId);
    }))
      .then(function (htmls) {
        if (id !== instantFilterRequestId) return;

        if (fetchUrls.length === 1) {
          var doc = new DOMParser().parseFromString(htmls[0], 'text/html');
          var newGridWrap = doc.querySelector('[data-collection-infinite]');
          var oldGridWrap = document.querySelector('[data-collection-infinite]');
          if (newGridWrap && oldGridWrap) {
            oldGridWrap.replaceWith(document.importNode(newGridWrap, true));
          }
          applyDrawerAndToggleFromDoc(doc, wasDrawerOpen);
          finishInstantFilterApply(urlString, wasDrawerOpen);
          return;
        }

        applyMergedGridFromHtmls(htmls);
        var orProductCount = sumOrFilterProductCounts(htmls);
        if (orProductCount === 0) {
          var mergedGrid = document.querySelector('[data-collection-infinite]');
          if (mergedGrid) {
            var visibleCards = mergedGrid.querySelectorAll('.tambur-product-card').length;
            if (visibleCards > 0) orProductCount = visibleCards;
          }
        }
        return fetchSectionHtml(targetUrl, sectionId).then(function (drawerHtml) {
          if (id !== instantFilterRequestId) return;
          var drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          applyDrawerAndToggleFromDoc(drawerDoc, wasDrawerOpen);
          setFilterProductCount(orProductCount);
          mergeOrFacetFiltersFromHtmls(htmls);
          finishInstantFilterApply(urlString, wasDrawerOpen);
        });
      })
      .catch(function () {
        if (id === instantFilterRequestId) window.location.href = urlString;
      })
      .finally(function () {
        if (id !== instantFilterRequestId) return;
        var gw = document.querySelector('[data-collection-infinite]');
        if (gw) gw.classList.remove('is-loading');
        var liveDrawer = getFiltersDrawer();
        if (liveDrawer) setFiltersDrawerLoading(liveDrawer, false);
      });
  }

  function stripAvailabilityParams(url) {
    var keys = [];
    url.searchParams.forEach(function (_, key) {
      if (isAvailabilityParam(key)) keys.push(key);
    });
    keys.forEach(function (key) {
      url.searchParams.delete(key);
    });
  }

  function isNicolaPatternTag(value) {
    return String(value || '').toLowerCase().indexOf('underkategori-nicola-fasano-') !== -1;
  }

  function isSabreSeriesTag(value) {
    return String(value || '').toLowerCase().indexOf('underkategori-sabre-') !== -1;
  }

  function stripNicolaPatternParams(url) {
    url.searchParams.delete('nf_pattern');
    url.searchParams.delete('filter.p.m.custom.monster');
    deleteFilterParamValues(url, 'filter.p.tag', isNicolaPatternTag);
    deleteFilterParamValues(url, 'filter.p.tag', isCeramikaPatternTag);
  }

  function stripSabreSeriesParams(url) {
    url.searchParams.delete('sabre_series');
    url.searchParams.delete('filter.p.m.custom.produktserie');
    deleteFilterParamValues(url, 'filter.p.tag', isSabreSeriesTag);
  }

  function stripLingeMonsterParams(url) {
    url.searchParams.delete('linge_monster');
    deleteFilterParamValues(url, 'filter.p.tag', isLingeMonsterTag);
  }

  function stripLingePtTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isLingePtTag);
  }

  function stripTamburPtTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isTamburPtTag);
  }

  function stripTamburFacetParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isTamburFacetTag);
    deleteFilterParamValues(url, 'filter.p.tag', isTamburKollektionTag);
    // Kuddarnas facetter i metafältsform. monster städas av
    // stripNicolaPatternParams, som körs i samma svep.
    url.searchParams.delete('filter.p.m.custom.matt');
    url.searchParams.delete('filter.p.m.custom.yta');
    url.searchParams.delete('filter.p.m.custom.textilkollektion');
  }

  function stripTamburKolParams(url) {
    deleteFilterParamValues(url, 'tambur_kol');
  }

  function deleteFilterParamValues(url, paramName, predicate) {
    var toDelete = [];
    url.searchParams.forEach(function (val, key) {
      if (key === paramName && (!predicate || predicate(val))) toDelete.push(val);
    });
    toDelete.forEach(function (val) {
      url.searchParams.delete(paramName, val);
    });
  }

  function appendFilterParamValues(url, paramName, values) {
    values.forEach(function (val) {
      if (val) url.searchParams.append(paramName, val);
    });
  }

  function isBordTondoTag(val) {
    var v = String(val || '').toLowerCase();
    return v === 'tondo-ampio' || v === 'tondo-cono' || v === 'tondo-piccolo-cono';
  }

  function isLampskarmTypeTag(val) {
    var v = String(val || '').toLowerCase();
    return (
      v === 'underkategori-lampskarm-cono' ||
      v === 'underkategori-lampskarm-cono-piccolo' ||
      v === 'underkategori-lampskarm-ampio'
    );
  }

  function isLampfotTypeTag(val) {
    var v = String(val || '').toLowerCase();
    return v === 'underkategori-lampfot-tondo' || v === 'underkategori-lampfot-tondo-piccolo';
  }

  function stripBordTondoTagParams(url) {
    deleteFilterParamValues(url, 'filter.p.tag', isBordTondoTag);
    deleteFilterParamValues(url, 'filter.p.tag', isLampskarmTypeTag);
    deleteFilterParamValues(url, 'filter.p.tag', isLampfotTypeTag);
    url.searchParams.delete('bord_tondo');
    url.searchParams.delete('filter.p.m.custom.bordslampa_serie');
    url.searchParams.delete('filter.p.m.custom.lamptyp');
  }

  function stripAllProductTypeFilterParams(url) {
    deleteFilterParamValues(url, 'filter.p.product_type');
    url.searchParams.delete('nf_type');
    url.searchParams.delete('kok_type');
    url.searchParams.delete('textil_type');
    url.searchParams.delete('linge_type');
    url.searchParams.delete('tambur_type');
    url.searchParams.delete('tambur_kol');
    url.searchParams.delete('sabre_type');
  }

  function applyShopifyFilterUrl(targetUrl, urlAdd, urlRemove, enabled) {
    var addUrl = new URL(urlAdd, window.location.origin);
    var removeUrl = new URL(urlRemove, window.location.origin);

    addUrl.searchParams.forEach(function (val, key) {
      if (key.indexOf('filter.') !== 0) return;
      if (enabled) {
        targetUrl.searchParams.set(key, val);
      } else if (!removeUrl.searchParams.has(key)) {
        targetUrl.searchParams.delete(key);
      } else {
        targetUrl.searchParams.set(key, removeUrl.searchParams.get(key));
      }
    });
  }

  function initProductCountUpdater(drawer) {
    var sectionId = drawer.getAttribute('data-section-id');
    var countEl = drawer.querySelector('[data-collection-filter-count]');
    var debounceTimer = null;
    var requestId = 0;
    var controller = null;

    function buildPendingFilterUrl() {
      // Utgå från filtreringen som är på väg in när en hämtning pågår, annars tappas
      // det man just klickade i om nästa klick kommer innan sidan hunnit uppdateras.
      var url = new URL(drawer._pendingFilterUrl || window.location.href, window.location.origin);
      url.searchParams.delete('page');

      drawer.querySelectorAll('[data-filter-price]').forEach(function (wrap) {
        if (wrap._priceState && wrap._priceState.applyToUrl) wrap._priceState.applyToUrl(url);
      });

      var availabilityBtns = drawer.querySelectorAll('[data-filter-availability]');
      var anyAvailabilityActive = false;
      availabilityBtns.forEach(function (btn) {
        if (btn.classList.contains('is-active')) anyAvailabilityActive = true;
      });

      if (!anyAvailabilityActive) {
        stripAvailabilityParams(url);
      } else {
        availabilityBtns.forEach(function (btn) {
          if (btn._availabilityState && btn._availabilityState.applyToUrl) btn._availabilityState.applyToUrl(url);
        });
      }

      var activePatternTags = [];
      var activePatternMfValues = [];
      var activeSabreSeriesTags = [];
      var activeLingeMonsterTags = [];
      var activeLingeMonsterMfValues = [];
      var activeTamburFacetTags = [];
      // metafältsnyckel -> värden. Kuddarnas facetter ligger i olika fält
      // (monster, matt, yta, textilkollektion) och får inte blandas.
      var activeTamburFacetMf = {};
      var activeTamburKolSlugs = [];
      var activeBordTondo = '';
      var activeLampMfValue = '';
      drawer.querySelectorAll('[data-filter-pattern].is-active').forEach(function (btn) {
        var tag = btn.getAttribute('data-pattern-tag') || '';
        if (!tag) return;
        if (isLingeMonsterTag(tag)) {
          activeLingeMonsterTags.push(tag);
          var lingeMfVal = btn.getAttribute('data-pattern-mf-value') || '';
          if (lingeMfVal && activeLingeMonsterMfValues.indexOf(lingeMfVal) === -1) {
            activeLingeMonsterMfValues.push(lingeMfVal);
          }
        } else if (isSabreSeriesTag(tag)) activeSabreSeriesTags.push(tag);
        else if (isNicolaPatternTag(tag) || isCeramikaPatternTag(tag)) {
          activePatternTags.push(tag);
          var mfVal = btn.getAttribute('data-pattern-mf-value') || '';
          if (mfVal && activePatternMfValues.indexOf(mfVal) === -1) activePatternMfValues.push(mfVal);
        } else if (isTamburKollektionTag(tag)) {
          activeTamburKolSlugs.push(tag.replace(/^tambur-kollektion-/i, ''));
        } else if (isTamburFacetTag(tag)) {
          // Facetterna filtreras via metafält (fungerar på alla språk, till skillnad
          // från taggfilter). Chipset bär nyckeln; saknas den skickas taggen som förut.
          var facetMfVal = btn.getAttribute('data-pattern-mf-value') || '';
          var facetMfKey = btn.getAttribute('data-pattern-mf-key') || '';
          if (facetMfVal && facetMfKey) {
            if (!activeTamburFacetMf[facetMfKey]) activeTamburFacetMf[facetMfKey] = [];
            if (activeTamburFacetMf[facetMfKey].indexOf(facetMfVal) === -1) {
              activeTamburFacetMf[facetMfKey].push(facetMfVal);
            }
          } else {
            activeTamburFacetTags.push(tag);
          }
        }
      });
      drawer.querySelectorAll('[data-filter-bord-tondo].is-active').forEach(function (btn) {
        var bordVal = btn.getAttribute('data-bord-tondo-value') || '';
        if (bordVal) activeBordTondo = bordVal;
        var lampMfVal = btn.getAttribute('data-lamp-mf-value') || '';
        if (lampMfVal) activeLampMfValue = lampMfVal;
      });
      stripNicolaPatternParams(url);
      stripSabreSeriesParams(url);
      stripLingeMonsterParams(url);
      stripTamburFacetParams(url);
      stripTamburKolParams(url);
      stripBordTondoTagParams(url);
      if (
        activePatternMfValues.length === 0 &&
        activePatternTags.length === 0 &&
        (isNicolaFasanoCollectionPath(url.pathname) || isCeramikaCollectionPath(url.pathname))
      ) {
        // Mönstret kan ligga i URL:en utan att ha något chip i lådan — äldre
        // bokmärken och länkar med nf_pattern. Då bär URL:en valet och ska följa
        // med. Finns chipset däremot är den släckta rutan användarens egen
        // avmarkering, och att läsa tillbaka mönstret gjorde det omöjligt att
        // klicka bort.
        var nfChipTags = {};
        var nfChipMfValues = {};
        drawer.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
          var chipTag = btn.getAttribute('data-pattern-tag') || '';
          if (!isNicolaPatternTag(chipTag) && !isCeramikaPatternTag(chipTag)) return;
          nfChipTags[chipTag.toLowerCase()] = true;
          var chipMfVal = btn.getAttribute('data-pattern-mf-value') || '';
          if (chipMfVal) nfChipMfValues[chipMfVal.toLowerCase()] = true;
        });
        var curUrl = new URL(window.location.href);
        curUrl.searchParams.forEach(function (val, key) {
          if (key === 'filter.p.m.custom.monster' && val) {
            if (!nfChipMfValues[String(val).toLowerCase()]) activePatternMfValues.push(val);
          } else if (
            key === 'filter.p.tag' &&
            (isNicolaPatternTag(val) || isCeramikaPatternTag(val))
          ) {
            if (!nfChipTags[String(val).toLowerCase()]) activePatternTags.push(val);
          }
        });
        if (activePatternMfValues.length === 0 && activePatternTags.length === 0) {
          var legacyNf = curUrl.searchParams.get('nf_pattern');
          if (legacyNf) {
            var suffix = legacyNf.replace(/^nicola-fasano-/, '');
            var legacyTag = 'underkategori-nicola-fasano-' + suffix;
            if (suffix && !nfChipTags[legacyTag]) activePatternTags.push(legacyTag);
          }
        }
      }
      if (isNicolaFasanoCollectionPath(url.pathname) || isCeramikaCollectionPath(url.pathname)) {
        // Mönstret filtreras via metafältet custom.monster, inte filter.p.tag: Shopifys
        // taggfilter fungerar bara på butikens standardspråk och gav 0 träffar på engelska.
        // Samma skäl som för custom.kok_produkttyp längre ned. Taggen används fortfarande
        // som reserv för äldre länkar där chipset inte hunnit renderas.
        if (activePatternMfValues.length) {
          appendFilterParamValues(url, 'filter.p.m.custom.monster', activePatternMfValues);
        } else if (activePatternTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activePatternTags);
        }
      }
      if (isLingeParticulierCollectionPath(url.pathname)) {
        // Samma skäl som för Nicolas mönster: taggfilter ger 0 träffar på engelska,
        // metafältet custom.monster fungerar på alla språk. Enfärgad/Mönstrad delas
        // med prydnadskuddarnas mönsterfacett.
        if (activeLingeMonsterMfValues.length) {
          appendFilterParamValues(url, 'filter.p.m.custom.monster', activeLingeMonsterMfValues);
        } else if (activeLingeMonsterTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activeLingeMonsterTags);
        }
      }
      if (activeTamburFacetTags.length && isTamburFacetCollectionPath(url.pathname)) {
        appendFilterParamValues(url, 'filter.p.tag', activeTamburFacetTags);
      }
      if (isTamburFacetCollectionPath(url.pathname)) {
        Object.keys(activeTamburFacetMf).forEach(function (mfKey) {
          appendFilterParamValues(url, 'filter.p.m.custom.' + mfKey, activeTamburFacetMf[mfKey]);
        });
      }

      var activeProductTypes = [];
      var activeKokPtTags = [];
      var activeKokPtValues = [];
      var activeDetaljerTags = [];
      var activeKokMfValues = [];
      var activeTextilPtTags = [];
      var activeNicolaPtTags = [];
      var activeLingePtTags = [];
      var activeTamburPtTags = [];
      var activeFilterTypeTags = [];
      var onLingePath = isLingeParticulierCollectionPath(url.pathname);
      var onTamburPath = isTamburVendorCollectionPath(url.pathname);
      // Custom produkttyp-knappar ([data-filter-product-type]) vs Shopifys nativa
      // a[data-filter-chip] för filter.p.product_type (t.ex. /collections/all).
      // Strip+rebuild får BARA köras när knapparna äger valet — annars raderar
      // stripAllProductTypeFilterParams URL-parametrarna och Visa/overlay-bekräfta
      // bygger en tom URL (filter försvinner trots instant-apply).
      var hasProductTypeButtons = !!drawer.querySelector('[data-filter-product-type]');
      if (hasProductTypeButtons) {
      drawer.querySelectorAll('[data-filter-product-type].is-active').forEach(function (btn) {
        var detaljerTag = btn.getAttribute('data-detaljer-tag') || '';
        if (detaljerTag) {
          if (activeDetaljerTags.indexOf(detaljerTag) === -1) activeDetaljerTags.push(detaljerTag);
          return;
        }
        var typeVal = btn.getAttribute('data-product-type-value') || '';
        // Varumärkessidor (fallback) vars produkttyp styrs av metafältet
        // custom.kok_produkttyp: filtrera via metafält i stället för filter.p.product_type
        // (native product_type är tom på dessa produkter → 0 träffar). Metafält fungerar
        // dessutom flerspråkigt.
        var kokMfVal = btn.getAttribute('data-kok-mf-value') || '';
        if (kokMfVal) {
          if (activeKokMfValues.indexOf(kokMfVal) === -1) activeKokMfValues.push(kokMfVal);
        } else if (typeVal) {
          activeProductTypes.push(typeVal);
        }
        // Chips som bär ett metafältvärde ska INTE också skicka sin gamla tagg:
        // Shopify skulle då snitta tagg och metafält, vilket ger noll träffar på
        // engelska där taggfiltret inte matchar något.
        var tamburPtTag = kokMfVal ? '' : btn.getAttribute('data-tambur-pt-tag') || '';
        if (tamburPtTag) activeTamburPtTags.push(tamburPtTag);
        var kokTag = kokMfVal ? '' : btn.getAttribute('data-kok-pt-tag') || '';
        if (kokTag && !isSabreCollectionPath(url.pathname, drawer)) {
          activeKokPtTags.push(kokTag);
          if (typeVal) activeKokPtValues.push(typeVal);
          if (onLingePath && isLingePtTag(kokTag) && activeLingePtTags.indexOf(kokTag) === -1) {
            activeLingePtTags.push(kokTag);
          }
        }
        var textilTag = kokMfVal ? '' : btn.getAttribute('data-textil-pt-tag') || '';
        if (textilTag) activeTextilPtTags.push(textilTag);
        var nicolaTag = kokMfVal ? '' : btn.getAttribute('data-nicola-pt-tag') || '';
        if (nicolaTag) activeNicolaPtTags.push(nicolaTag);
        var filterTypeTag = kokMfVal ? '' : btn.getAttribute('data-filter-type-tag') || '';
        if (filterTypeTag) activeFilterTypeTags.push(filterTypeTag);
      });
      activeFilterTypeTags.forEach(function (tag) {
        if (isLingePtTag(tag) && activeLingePtTags.indexOf(tag) === -1) activeLingePtTags.push(tag);
      });
      stripKokPtTagParams(url);
      stripTextilPtTagParams(url);
      stripNicolaPtTagParams(url);
      stripLingePtTagParams(url);
      stripTamburPtTagParams(url);
      stripAllProductTypeFilterParams(url);
      if (isNicolaFasanoCollectionPath(url.pathname)) {
        if (activeNicolaPtTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activeNicolaPtTags);
        }
      } else if (isLingeParticulierCollectionPath(url.pathname)) {
        if (activeLingePtTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activeLingePtTags);
        }
      } else if (isKokCollectionPath(url.pathname)) {
        // Produkttyp filtreras via metafält (filter.p.m.custom.kok_produkttyp) i stället
        // för filter.p.tag=kok-pt-*. Anledning: Shopifys tagg-/produkttyp-filter fungerar
        // BARA på butikens standardspråk (svenska); på engelska ger de 0 träffar. Metafält-
        // filter fungerar på alla språk. Värdet är den svenska etiketten (samma på alla
        // språk) — chipets synliga text översätts separat i temat.
        url.searchParams.delete('filter.p.m.custom.kok_produkttyp');
        if (activeKokPtValues.length) {
          appendFilterParamValues(url, 'filter.p.m.custom.kok_produkttyp', activeKokPtValues);
        }
      } else if (isTextilCollectionPath(url.pathname)) {
        if (activeTextilPtTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activeTextilPtTags);
        }
      } else if (isSabreCollectionPath(url.pathname, drawer)) {
        var sabreSeriesHandle = '';
        var sabreSeriesTag = '';
        var sabreSeriesMfValue = '';
        drawer.querySelectorAll('[data-filter-pattern].is-active').forEach(function (btn) {
          var seriesTag = btn.getAttribute('data-pattern-tag') || '';
          if (isSabreSeriesTag(seriesTag)) {
            sabreSeriesHandle = btn.getAttribute('data-pattern-handle') || '';
            sabreSeriesTag = seriesTag;
            sabreSeriesMfValue = btn.getAttribute('data-pattern-mf-value') || '';
          }
        });
        if (sabreSeriesHandle) url.searchParams.set('sabre_series', sabreSeriesHandle);
        // Serien filtreras via metafältet custom.produktserie av samma skäl som
        // mönstret ovan: taggfiltret gav noll träffar på engelska. Taggen är reserv
        // för äldre länkar där chipset inte hunnit renderas.
        if (sabreSeriesMfValue) {
          appendFilterParamValues(url, 'filter.p.m.custom.produktserie', [sabreSeriesMfValue]);
        } else if (sabreSeriesTag) {
          appendFilterParamValues(url, 'filter.p.tag', [sabreSeriesTag]);
        }

        // Produkttypen skickas som custom.kok_produkttyp av metafältsblocket längre
        // ned. Taggen får då inte följa med: Shopify snittar tagg och metafält, och
        // taggfiltret matchar inget på engelska — resultatet blir noll träffar.
        var sabreActiveKokPtTags = [];
        var sabreHasKokMfValue = false;
        drawer.querySelectorAll('[data-filter-product-type].is-active').forEach(function (btn) {
          if (btn.getAttribute('data-kok-mf-value')) {
            sabreHasKokMfValue = true;
            return;
          }
          var sabreKokTag = btn.getAttribute('data-kok-pt-tag') || '';
          if (sabreKokTag) sabreActiveKokPtTags.push(sabreKokTag);
        });
        if (!sabreHasKokMfValue && sabreActiveKokPtTags.length === 1) {
          appendFilterParamValues(url, 'filter.p.tag', sabreActiveKokPtTags);
        }
      } else if (onTamburPath) {
        if (activeTamburPtTags.length) {
          appendFilterParamValues(url, 'filter.p.tag', activeTamburPtTags);
        }
      } else if (activeProductTypes.length) {
        appendFilterParamValues(url, 'filter.p.product_type', activeProductTypes);
      }

      // Metafält-baserade produkttyp-chips (varumärkessidor): emittera alltid, oavsett
      // gren ovan. Hanteras separat från native product_type eftersom dessa produkter
      // saknar product_type och i stället taggas via custom.kok_produkttyp.
      //
      // OBS: detta gäller BARA sidor där produkttypen renderas som
      // [data-filter-product-type]-KNAPPAR med data-kok-mf-value (varumärkes-/lampsidor).
      // På generiska kategorisidor (t.ex. Mattor) är custom.kok_produkttyp i stället ett
      // nativt Shopify-metafält-filter som renderas som vanliga [data-filter-chip]-ankare.
      // Då finns inga knappar att läsa värden från — strippa då INTE parametern, utan
      // bevara den som ligger i URL:en (instant-apply håller den korrekt via pushState).
      // Annars tappas filtret när man klickar "Visa".
      var hasKokMfButtons = !!drawer.querySelector('[data-filter-product-type][data-kok-mf-value]');
      if (!isKokCollectionPath(url.pathname) && hasKokMfButtons) {
        url.searchParams.delete('filter.p.m.custom.kok_produkttyp');
        if (activeKokMfValues.length) {
          appendFilterParamValues(url, 'filter.p.m.custom.kok_produkttyp', activeKokMfValues);
        }
      }
      if (drawer.querySelector('[data-detaljer-tag]')) {
        deleteFilterParamValues(url, 'filter.p.tag', isDetaljerTag);
        if (activeDetaljerTags.length) appendFilterParamValues(url, 'filter.p.tag', activeDetaljerTags);
      }
      } // end hasProductTypeButtons — native product_type chips keep URL as-is

      var bordslamporFilterActive = isBordslamporFilterContext(
        url.pathname,
        activeProductTypes,
        activeTamburPtTags
      );
      if (bordslamporFilterActive) {
        activeTamburKolSlugs = [];
        stripTamburKolParams(url);
      }
      if (
        activeBordTondo &&
        (bordslamporFilterActive ||
          isLampskarmarCollectionPath(url.pathname) ||
          isLampfotterCollectionPath(url.pathname))
      ) {
        if (isBordTondoTag(activeBordTondo)) {
          // Bordslampe-serie (tondo-ampio/tondo-cono/tondo-piccolo-cono) filtreras via
          // metafält så det fungerar på alla språk.
          appendFilterParamValues(url, 'filter.p.m.custom.bordslampa_serie', [activeBordTondo]);
        } else if (activeLampMfValue) {
          // Lampfot-/lampskärmstyp, av samma skäl: taggfiltret gav noll träffar på
          // engelska. Värdet är chipets etikett ("Cono", "Lampfot Tondo").
          appendFilterParamValues(url, 'filter.p.m.custom.lamptyp', [activeLampMfValue]);
        } else {
          appendFilterParamValues(url, 'filter.p.tag', [activeBordTondo]);
        }
      }
      if (activeTamburKolSlugs.length && isTamburVendorCollectionPath(url.pathname)) {
        activeTamburKolSlugs.forEach(function (slug) {
          if (slug) url.searchParams.append('tambur_kol', slug);
        });
      }

      var vendorSection = findVendorFilterSection(drawer);
      if (vendorSection) {
        var pendingVendorValues = [];
        vendorSection.querySelectorAll('[data-filter-chip].is-active').forEach(function (chip) {
          var vendorLabel = collectFacetChipLabel(chip);
          if (vendorLabel) pendingVendorValues.push(vendorLabel);
        });
        if (pendingVendorValues.length) {
          deleteFilterParamValues(url, 'filter.p.vendor');
          pendingVendorValues.forEach(function (vendorVal) {
            url.searchParams.append('filter.p.vendor', vendorVal);
          });
        }
      }

      // Undersidor i Kök (t.ex. Djupa tallrikar) visar hela gruppens produkttyper (Anders 2026-10-22).
      // Väljs en typ som inte finns på sidan går filtret till gruppens sida (t.ex. Duka bordet).
      var kokGruppSection = drawer.querySelector('[data-kok-grupp-url]');
      if (kokGruppSection) {
        var kokUtanfor = false;
        kokGruppSection.querySelectorAll('[data-filter-product-type].is-active').forEach(function (btn) {
          if (btn.getAttribute('data-egen') !== '1') kokUtanfor = true;
        });
        if (kokUtanfor) {
          url.pathname = new URL(kokGruppSection.getAttribute('data-kok-grupp-url'), window.location.origin).pathname;
        }
      }

      return url;
    }

    drawer._buildPendingFilterUrl = buildPendingFilterUrl;

    if (drawer.getAttribute('data-count-bound') === 'true') return;
    drawer.setAttribute('data-count-bound', 'true');

    function setCountLoading(loading) {
      if (!countEl) return;
      countEl.classList.toggle('is-loading', loading);
    }

    function setCountValue(value) {
      if (!countEl || value === null || value === undefined) return;
      countEl.textContent = String(value);
    }

    function resetCountToPage() {
      var wrap = document.querySelector('[data-collection-infinite]');
      var base = wrap && wrap.getAttribute('data-products-count');
      if (base) setCountValue(base);
      else setCountValue(drawer.getAttribute('data-base-products-count'));
    }

    function fetchProductCount(immediate) {
      if (!sectionId || !countEl) return;

      clearTimeout(debounceTimer);

      var run = function () {
        var id = ++requestId;
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        setCountLoading(true);

        var url = buildPendingFilterUrl();
        var fetchUrls = buildOrFilterFetchUrls(url);

        Promise.all(
          fetchUrls.map(function (u) {
            return fetchSectionHtml(u, sectionId);
          })
        )
          .then(function (htmls) {
            if (id !== requestId) return;
            if (fetchUrls.length === 1) {
              var doc = new DOMParser().parseFromString(htmls[0], 'text/html');
              var singleCount = readSectionProductCount(doc);
              if (singleCount !== null) setCountValue(singleCount);
              return;
            }
            var orGroups = parseOrFilterGroups(url);
            if (orGroups.length === 1) {
              setCountValue(sumOrFilterProductCounts(htmls));
              return;
            }
            var handles = {};
            htmls.forEach(function (html) {
              var countDoc = new DOMParser().parseFromString(html, 'text/html');
              countDoc.querySelectorAll('.tambur-product-card').forEach(function (card) {
                var handle = card.getAttribute('data-product-handle');
                if (handle) handles[handle] = true;
              });
            });
            setCountValue(Object.keys(handles).length);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
          })
          .finally(function () {
            if (id === requestId) setCountLoading(false);
          });
      };

      if (immediate) {
        run();
      } else {
        debounceTimer = setTimeout(run, 280);
      }
    }

    drawer._refreshProductCount = function (immediate) {
      fetchProductCount(immediate);
    };

    drawer._resetProductCount = resetCountToPage;
  }

  function sectionHasActiveFilters(section) {
    if (section.querySelector('.tambur-collection-filters__section-badge')) return true;
    if (section.querySelector('.tambur-collection-filters__chip.is-active')) return true;
    if (section.querySelector('.tambur-collection-filters__pattern-chip.is-active')) return true;
    if (section.querySelector('.tambur-collection-filters__checkbox.is-active')) return true;
    if (section.querySelector('[data-filter-price]')) {
      var priceWrap = section.querySelector('[data-filter-price]');
      if (priceWrap) {
        var maxCents = parseInt(priceWrap.getAttribute('data-price-range-max'), 10) || 0;
        var minCents = parseInt(priceWrap.getAttribute('data-price-min-cents'), 10) || 0;
        var maxSel = parseInt(priceWrap.getAttribute('data-price-max-cents'), 10) || maxCents;
        if (minCents > 0 || (maxCents > 0 && maxSel < maxCents)) return true;
      }
    }
    return false;
  }

  function getFilterSectionKey(section) {
    if (!section) return '';
    var title = section.querySelector('.tambur-collection-filters__section-title');
    if (!title) return '';
    var clone = title.cloneNode(true);
    clone.querySelectorAll('.tambur-collection-filters__section-badge').forEach(function (badge) {
      badge.remove();
    });
    return clone.textContent.trim().toLowerCase();
  }

  // Alla grupper är öppna från början (ny design, Anders 2026-10-22). En grupp
  // som besökaren fäller ihop förblir hopfälld när panelen hämtas om efter ett
  // val; tidigare var bara en grupp åt gången öppen.
  var hopfalldaFilterSektioner = {};

  function normalizeFilterAccordion(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('.tambur-collection-filters__section[data-filter-accordion]').forEach(function (section) {
      setTamburSectionCollapsed(section, !!hopfalldaFilterSektioner[getFilterSectionKey(section)]);
    });
  }

  function initFilterAccordions(scope, options) {
    options = options || {};
    var drawer = scope.closest('[data-collection-filters-drawer]') || scope;
    if (!drawer) return;

    drawer.querySelectorAll('.tambur-collection-filters__section').forEach(function (section) {
      if (section.getAttribute('data-accordion-bound') === 'true') return;

      var title = section.querySelector(':scope > .tambur-collection-filters__section-title');
      if (!title || section.querySelector('[data-filter-accordion-trigger]')) return;

      section.setAttribute('data-accordion-bound', 'true');
      section.setAttribute('data-filter-accordion', '');

      var expanded = sectionHasActiveFilters(section);

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'tambur-collection-filters__accordion-trigger';
      trigger.setAttribute('data-filter-accordion-trigger', '');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      var chevron = document.createElement('span');
      chevron.className = 'tambur-collection-filters__accordion-chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML =
        '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1.5l5 5 5-5"/></svg>';

      trigger.appendChild(title);
      trigger.appendChild(chevron);
      section.insertBefore(trigger, section.firstChild);

      var body = document.createElement('div');
      body.className = 'tambur-collection-filters__section-body';
      var bodyInner = document.createElement('div');
      bodyInner.className = 'tambur-collection-filters__section-body-inner';
      while (trigger.nextSibling) {
        bodyInner.appendChild(trigger.nextSibling);
      }
      body.appendChild(bodyInner);
      section.appendChild(body);

      if (!expanded) section.classList.add('is-collapsed');

      trigger.addEventListener('click', function () {
        var hopfall = !section.classList.contains('is-collapsed');
        hopfalldaFilterSektioner[getFilterSectionKey(section)] = hopfall;
        setTamburSectionCollapsed(section, hopfall);
      });
    });

    normalizeFilterAccordion(drawer);
  }

  function initCollectionFilters(root, options) {
    requestAnimationFrame(synkaFilterAntal);
    options = options || {};
    var scope = root || document;
    var drawer = scope.querySelector('[data-collection-filters-drawer]');
    var panel = scope.querySelector('[data-collection-filters]');
    var toggle = scope.querySelector('[data-collection-filter-toggle]');
    if (!drawer || !panel) return;

    var lastFocus = null;

    initProductCountUpdater(drawer);
    syncOrFacetsIfNeeded(drawer);

    function dismissDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tambur-collection-filters-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-active');
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Visa: behåll valen, se till att pending state ligger i URL:en, stäng utan att
    // revert:a. Tidigare fullsidesnavigering + closeDrawer (som revert:ar) gjorde att
    // Visa antingen verkade dö eller undoingade valet, medan X lämnade instant-apply.
    // Synka chip-UI från URL först (Sabré m.fl. metafältfilter) så apply inte bygger
    // en tom URL och rensar det som redan instant-applyats.
    function confirmDrawerFilters() {
      syncProductTypeChipsFromUrl(drawer);
      syncSabreProductTypeChipsFromUrl(drawer);
      syncSabreSeriesChipsFromUrl(drawer);
      dismissDrawer();
      applyDrawerFilters(drawer);
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      // Chip-X synkar URL/grid men kan lämna stale is-active i drawern — läs om från URL.
      syncProductTypeChipsFromUrl(drawer);
      syncSabreProductTypeChipsFromUrl(drawer);
      syncVendorChipsFromUrl(drawer);
      syncSabreSeriesChipsFromUrl(drawer);
      syncTamburKollektionChipsFromUrl(drawer);
      syncBordTondoChipsFromUrl(drawer);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tambur-collection-filters-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('is-active');
      }
      syncPrydnadskuddarFacetAvailability(drawer);
      panel.focus();
    }

    // Alla sätt att stänga behåller valen (Anders 2026-10-22): X, Escape,
    // klick utanför, filterknappen och Visa. Tidigare ångrade X och Escape
    // allt som valts sedan lådan öppnades, så ett valt filter försvann när
    // man stängde med krysset. Ett filter tas bort genom att klicka ur det.
    var closeDrawer = confirmDrawerFilters;

    if (toggle && toggle.getAttribute('data-filter-bound') !== 'true') {
      toggle.setAttribute('data-filter-bound', 'true');
      toggle.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawer.getAttribute('data-filter-drawer-bound') !== 'true') {
      drawer.setAttribute('data-filter-drawer-bound', 'true');

      // Overlay / backdrop (data-collection-filters-close, inte X-knappen).
      drawer.querySelectorAll('[data-collection-filters-close]').forEach(function (el) {
        if (el.classList.contains('tambur-collection-filters__close')) return;
        el.addEventListener('click', function () {
          confirmDrawerFilters();
        });
      });

      bindCloseSpin(
        drawer.querySelector('.tambur-collection-filters__close'),
        '.tambur-collection-filters__close-icon',
        closeDrawer
      );

      var applyBtn = drawer.querySelector('[data-collection-filters-apply]');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          confirmDrawerFilters();
        });
      }

      // Lådan byts ut vid instant-apply och varje ny låda binder en egen
      // lyssnare här. En utbytt låda (inte längre i DOM:en) ska inte reagera,
      // annars bygger den filter-URL:en ur sitt gamla läge och tappar val.
      document.addEventListener('keydown', function (e) {
        if (!drawer.isConnected) return;
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      drawer.addEventListener('click', function (e) {
        // Rensa filter: tillbaka till kollektionen utan filter, panelen står kvar öppen
        var clearAll = e.target.closest('[data-collection-filters-clear-all]');
        if (clearAll) {
          e.preventDefault();
          var bas = drawer.getAttribute('data-collection-url') || window.location.pathname;
          applyCollectionFiltersInstant(new URL(bas, window.location.origin).toString(), drawer);
          return;
        }

        var chip = e.target.closest('a[data-filter-chip]');
        if (chip && isInstantFilterChip(chip)) {
          e.preventDefault();
          var chipUrl = rebaseFilterHrefOnPendingUrl(chip.getAttribute('href'), drawer);
          chip.classList.toggle('is-active');
          applyCollectionFiltersInstant(chipUrl, drawer);
          return;
        }

        var clearLink = e.target.closest('.tambur-collection-filters__clear a');
        if (clearLink && isInstantFilterClear(clearLink)) {
          e.preventDefault();
          applyCollectionFiltersInstant(clearLink.href, drawer);
        }
      });

      initPriceSliders(drawer);
      initAvailabilityCheckboxes(drawer);
      initPatternFilters(drawer);
      initFilterAccordions(drawer, options);
    }

    syncTamburVendorFilterAvailability(drawer);
    syncLampParentFilterAvailability(drawer);
    syncPrydnadskuddarFacetAvailability(drawer);
    syncTamburKollektionChipsFromUrl(drawer);
    syncBordTondoChipsFromUrl(drawer);
    syncSabreSeriesChipsFromUrl(drawer);
    syncProductTypeChipsFromUrl(drawer);
    syncSabreProductTypeChipsFromUrl(drawer);
    syncVendorChipsFromUrl(drawer);
    sortProductTypeFilterChips(drawer);
    sortVendorFilterChips(drawer);
    loadPorslinVendorChipCache(drawer);
    ensurePorslinSubcategoryVendorChips(drawer);
  }

  function ensureDrawerFilterUrl(drawer) {
    if (!drawer._buildPendingFilterUrl) {
      initProductCountUpdater(drawer);
    }
    return drawer._buildPendingFilterUrl;
  }

  function applyDrawerFilters(drawer) {
    if (!ensureDrawerFilterUrl(drawer)) return;
    var url = drawer._buildPendingFilterUrl().toString();
    var target = new URL(url, window.location.origin);
    var current = new URL(window.location.href);
    if (target.pathname + target.search === current.pathname + current.search) return;
    applyCollectionFiltersInstant(url, drawer);
  }

  function handleProductTypeChipClick(btn) {
    var drawer = btn.closest('[data-collection-filters-drawer]');
    if (!drawer) return;

    var nextActive = !btn.classList.contains('is-active');
    if (nextActive && isLingeParticulierCollectionPath(window.location.pathname)) {
      drawer.querySelectorAll('[data-filter-product-type]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    if (nextActive && isTamburVendorCollectionPath(window.location.pathname)) {
      drawer.querySelectorAll('[data-filter-product-type]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    if (nextActive && isLampParentCollectionPath(window.location.pathname)) {
      drawer.querySelectorAll('[data-filter-product-type]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    if (nextActive && isSabreCollectionPath(window.location.pathname, drawer)) {
      drawer.querySelectorAll('[data-filter-product-type]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    btn.classList.toggle('is-active', nextActive);
    btn.setAttribute('aria-pressed', nextActive ? 'true' : 'false');

    if (nextActive && btn.getAttribute('data-product-type-value') === 'Bordslampor') {
      var kolSection = drawer.querySelector('.tambur-collection-filters__section--tambur-kollektion');
      if (kolSection) {
        kolSection.querySelectorAll('[data-filter-pattern].is-active').forEach(function (chip) {
          if (isTamburKollektionTag(chip.getAttribute('data-pattern-tag') || '')) {
            chip.classList.remove('is-active');
            chip.setAttribute('aria-pressed', 'false');
          }
        });
      }
    }

    if (nextActive && btn.getAttribute('data-product-type-value') !== 'Bordslampor') {
      var bordTondoSection = drawer.querySelector('.tambur-collection-filters__section--bord-tondo');
      if (bordTondoSection) {
        bordTondoSection.querySelectorAll('[data-filter-bord-tondo].is-active').forEach(function (chip) {
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
        });
      }
    }

    if (isSabreCollectionPath(window.location.pathname, drawer)) {
      var ptSection = btn.closest('.tambur-collection-filters__section--product-type');
      if (ptSection) setTamburSectionCollapsed(ptSection, false);
    }

    syncTamburVendorFilterAvailability(drawer);
    syncLampParentFilterAvailability(drawer);
    syncPrydnadskuddarFacetAvailability(drawer);
    syncTamburKollektionChipsFromUrl(drawer);
    syncBordTondoChipsFromUrl(drawer);
    applyDrawerFilters(drawer);
  }

  function handleBordTondoChipClick(btn) {
    var drawer = btn.closest('[data-collection-filters-drawer]');
    if (!drawer) return;

    if (btn.classList.contains('is-disabled')) return;

    var nextActive = !btn.classList.contains('is-active');
    var bordTondoSection = btn.closest('.tambur-collection-filters__section--bord-tondo');
    if (nextActive && bordTondoSection) {
      bordTondoSection.querySelectorAll('[data-filter-bord-tondo]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    btn.classList.toggle('is-active', nextActive);
    btn.setAttribute('aria-pressed', nextActive ? 'true' : 'false');
    applyDrawerFilters(drawer);
  }

  function handlePatternChipClick(btn) {
    var drawer = btn.closest('[data-collection-filters-drawer]');
    if (!drawer) return;

    if (btn.classList.contains('is-disabled')) return;

    var nextActive = !btn.classList.contains('is-active');
    var mattSection = btn.closest('.tambur-collection-filters__section--tambur-matt');
    var kollektionSection = btn.closest('.tambur-collection-filters__section--tambur-kollektion');
    var sabreSeriesSection = btn.closest('.tambur-collection-filters__section--sabre-series');
    if (nextActive && sabreSeriesSection) {
      sabreSeriesSection.querySelectorAll('[data-filter-pattern]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    if (nextActive && mattSection) {
      mattSection.querySelectorAll('[data-filter-pattern]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
        var otherClear = other.querySelector('.tambur-collection-filters__pattern-clear');
        if (otherClear) otherClear.hidden = true;
      });
    }
    if (nextActive && kollektionSection) {
      kollektionSection.querySelectorAll('[data-filter-pattern]').forEach(function (other) {
        if (other === btn) return;
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
    }
    btn.classList.toggle('is-active', nextActive);
    btn.setAttribute('aria-pressed', nextActive ? 'true' : 'false');
    var clearEl = btn.querySelector('.tambur-collection-filters__pattern-clear');
    if (clearEl) clearEl.hidden = !nextActive;

    syncPrydnadskuddarFacetAvailability(drawer);
    applyDrawerFilters(drawer);
  }

  if (!document.documentElement.hasAttribute('data-tambur-filter-chip-delegate')) {
    document.documentElement.setAttribute('data-tambur-filter-chip-delegate', 'true');
    document.addEventListener('click', function (e) {
      var activePill = e.target.closest('[data-active-filter-remove]');
      if (activePill) {
        e.preventDefault();
        e.stopPropagation();
        var removeParams = String(activePill.getAttribute('data-remove-params') || '')
          .split(',')
          .map(function (p) { return p.trim(); })
          .filter(Boolean);
        var pillDrawer = getFiltersDrawer();
        var nextUrl;
        if (removeParams.length) {
          nextUrl = new URL(
            (pillDrawer && pillDrawer._pendingFilterUrl) || window.location.href,
            window.location.origin
          );
          removeParams.forEach(function (param) {
            nextUrl.searchParams.delete(param);
          });
          nextUrl.searchParams.delete('page');
        } else {
          nextUrl = new URL(
            rebaseFilterHrefOnPendingUrl(activePill.getAttribute('href'), pillDrawer),
            window.location.origin
          );
        }
        applyCollectionFiltersInstant(nextUrl.toString());
        return;
      }
      var typeBtn = e.target.closest('[data-filter-product-type]');
      if (typeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeBtn.classList.contains('is-disabled') || typeBtn.getAttribute('aria-disabled') === 'true') return;
        handleProductTypeChipClick(typeBtn);
        return;
      }
      var patternBtn = e.target.closest('[data-filter-pattern]');
      if (patternBtn) {
        e.preventDefault();
        e.stopPropagation();
        handlePatternChipClick(patternBtn);
        return;
      }
      var bordTondoBtn = e.target.closest('[data-filter-bord-tondo]');
      if (bordTondoBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleBordTondoChipClick(bordTondoBtn);
      }
    });
  }

  function initPatternFilters(scope) {
    var drawer = scope.closest('[data-collection-filters-drawer]') || scope;
    var grid = drawer.querySelector('[data-filter-pattern-grid]');
    if (!grid) return;

    grid.querySelectorAll('[data-filter-pattern]').forEach(function (btn) {
      if (btn.getAttribute('data-pattern-bound') === 'true') return;
      btn.setAttribute('data-pattern-bound', 'true');

      var initialActive = btn.getAttribute('data-initial-active') === 'true';
      var isActive = initialActive;

      function setClearVisible(active) {
        var clearEl = btn.querySelector('.tambur-collection-filters__pattern-clear');
        if (clearEl) clearEl.hidden = !active;
      }

      function setUI(active) {
        isActive = active;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        setClearVisible(active);
      }

      btn._patternState = {
        revert: function () {
          setUI(initialActive);
        },
        deactivate: function () {
          setUI(false);
        },
      };

      setClearVisible(initialActive);
    });
  }

  if (!window.__tamburCollectionFiltersPopstateBound) {
    window.__tamburCollectionFiltersPopstateBound = true;
    window.addEventListener('popstate', function () {
      window.location.reload();
    });
  }

  function formatPriceCents(cents, currency) {
    var iso = currency || 'SEK';
    var amount = cents / 100;
    if (iso === 'EUR') {
      return String(Math.round(amount)) + ' EUR';
    }
    try {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: iso,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      }).format(amount);
    } catch (e) {
      return amount + ' ' + iso;
    }
  }

  function centsToParam(cents) {
    var amount = cents / 100;
    if (amount % 1 === 0) return String(Math.round(amount));
    return amount.toFixed(2).replace(/\.?0+$/, '');
  }

  function notifyPendingFilterChange(drawer, immediate) {
    if (drawer._refreshProductCount) drawer._refreshProductCount(immediate);
  }

  function initPriceSliders(scope) {
    var drawer = scope.closest('[data-collection-filters-drawer]') || scope;

    scope.querySelectorAll('[data-filter-price]').forEach(function (wrap) {
      if (wrap.getAttribute('data-price-bound') === 'true') return;
      wrap.setAttribute('data-price-bound', 'true');

      var maxCents = parseInt(wrap.getAttribute('data-price-range-max'), 10) || 0;
      if (maxCents <= 0) return;

      var minRange = wrap.querySelector('[data-price-min-range]');
      var maxRange = wrap.querySelector('[data-price-max-range]');
      var fill = wrap.querySelector('[data-price-range-fill]');
      var display = wrap.querySelector('[data-price-display]');
      var minParam = wrap.getAttribute('data-min-param');
      var maxParam = wrap.getAttribute('data-max-param');
      var currency = wrap.getAttribute('data-currency') || 'SEK';
      var initialMin = parseInt(wrap.getAttribute('data-price-min-cents'), 10) || 0;
      var initialMax = parseInt(wrap.getAttribute('data-price-max-cents'), 10) || maxCents;

      function getMin() {
        return parseInt(minRange.value, 10);
      }

      function getMax() {
        return parseInt(maxRange.value, 10);
      }

      function updateUI(activeThumb) {
        var min = getMin();
        var max = getMax();

        if (min > max) {
          if (activeThumb === minRange) {
            maxRange.value = min;
            max = min;
          } else {
            minRange.value = max;
            min = max;
          }
        }

        var pctMin = (min / maxCents) * 100;
        var pctMax = (max / maxCents) * 100;
        fill.style.left = pctMin + '%';
        fill.style.width = (pctMax - pctMin) + '%';

        if (display) {
          display.textContent = formatPriceCents(min, currency) + ' – ' + formatPriceCents(max, currency);
        }
      }

      wrap._priceState = {
        revert: function () {
          minRange.value = initialMin;
          maxRange.value = initialMax;
          updateUI();
        },
        applyToUrl: function (url) {
          var min = getMin();
          var max = getMax();

          if (min > 0) {
            url.searchParams.set(minParam, centsToParam(min));
          } else {
            url.searchParams.delete(minParam);
          }

          if (max < maxCents) {
            url.searchParams.set(maxParam, centsToParam(max));
          } else {
            url.searchParams.delete(maxParam);
          }
        },
      };

      minRange.addEventListener('input', function () {
        updateUI(minRange);
        notifyPendingFilterChange(drawer, false);
      });
      maxRange.addEventListener('input', function () {
        updateUI(maxRange);
        notifyPendingFilterChange(drawer, false);
      });

      updateUI();
    });
  }

  function initAvailabilityCheckboxes(scope) {
    var drawer = scope.closest('[data-collection-filters-drawer]') || scope;

    scope.querySelectorAll('[data-filter-availability]').forEach(function (btn) {
      if (btn.getAttribute('data-availability-bound') === 'true') return;
      btn.setAttribute('data-availability-bound', 'true');

      var initialActive = btn.getAttribute('data-initial-active') === 'true';
      var urlAdd = btn.getAttribute('data-url-add');
      var urlRemove = btn.getAttribute('data-url-remove');
      var isActive = initialActive;

      function setUI(active) {
        isActive = active;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      }

      btn._availabilityState = {
        revert: function () {
          setUI(initialActive);
        },
        applyToUrl: function (url) {
          if (isActive === initialActive) return;
          applyShopifyFilterUrl(url, urlAdd, urlRemove, isActive);
        },
        isActive: function () {
          return isActive;
        },
      };

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setUI(!isActive);
        // Lagerrutorna slår igenom direkt, som produkttyp- och varumärkeschipsen.
        // Tidigare stannade valet i lådan till man tryckte Visa, så raden med
        // aktiva filter visade inget för I webblager / I butikslager.
        applyDrawerFilters(drawer);
      });
    });
  }

  if (
    !stripTamburKolForBordslamporFilter() &&
    !migrateSabreSeriesUrlParams() &&
    !migrateTamburKollektionUrlParams()
  ) {
    preloadPrydnadskuddarFacetIndex();
    initCollectionFilters(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (
      !stripTamburKolForBordslamporFilter() &&
      !migrateSabreSeriesUrlParams() &&
      !migrateTamburKollektionUrlParams()
    ) {
      initCollectionFilters(e.target);
    }
  });
})();











